var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1641,
    height: 978.933,
    viewBox: "0 0 1641 978.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_816",
    "data-name": "Trazado 816",
    d: "M1264.246,805.68,820.724,792.94s23.223-38.317,47.381-87.706c12.224-24.99,24.686-52.815,34.5-79.945,7.041-19.463-25.1-45.906-18.809-64.975,11.629-35.256,53.512-27.12,52.151-60.7-2.565-63.265,46.366-55.571,44.457-96.608-1.71-36.762-19.664-66.685-19.664-66.685l303.5-15.8Z",
    transform: "translate(-820.724 -320.518)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_769",
    "data-name": "Trazado 769",
    d: "M313.715,297.123c-15.389-33.364-23.589-62.383-18.315-64.815s73.583-17.2,88.972,16.169S356.4,350.7,351.128,353.13,329.1,330.487,313.715,297.123Z",
    transform: "translate(-293.802 -226.963)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_772",
    "data-name": "Trazado 772",
    d: "M560.512,300.057C548.9,336.607,534.648,364.7,528.674,362.8s-41.64-40.94-30.03-77.491,66.1-56.768,72.071-54.87S572.121,263.507,560.512,300.057Z",
    transform: "translate(-496.336 -230.318)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_121",
    "data-name": "Elipse 121",
    cx: 15.882,
    cy: 15.882,
    r: 15.882,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_734",
    "data-name": "Rect\\xE1ngulo 734",
    width: 55.505,
    height: 68.569,
    transform: "translate(68.569 0) rotate(90)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_916",
    "data-name": "Rect\\xE1ngulo 916",
    width: 772.93,
    height: 189.208,
    transform: "translate(0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_835",
    "data-name": "Trazado 835",
    d: "M1363.433,517.139h117.283l39.686-51.226,31.6-64.356H1356.847Z",
    transform: "translate(-1356.847 -401.557)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_832",
    "data-name": "Trazado 832",
    d: "M1435.491,500.077c-12.356-26.791-18.94-50.093-14.706-52.046,2.118-.976,11.69-17.989,27.477-17.848s37.786,17.436,43.965,30.832c12.357,26.79-22.459,82.081-26.694,84.034S1447.848,526.867,1435.491,500.077Z",
    transform: "translate(-1419.501 -430.182)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_142",
    "data-name": "Elipse 142",
    cx: 9.398,
    cy: 9.398,
    r: 9.398,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_759",
    "data-name": "Rect\\xE1ngulo 759",
    width: 32.843,
    height: 40.574,
    transform: "translate(48.751 12.567) rotate(108.044)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1762",
    "data-name": "Grupo 1762",
    transform: "translate(5635.5 -1713)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_296",
    "data-name": "L\\xEDnea 296",
    y2: 110.014,
    transform: "translate(-4760.734 1957.346)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1715",
    "data-name": "Grupo 1715",
    transform: "translate(-4422.481 1985.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_956",
    "data-name": "Grupo 956"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_229",
    "data-name": "L\\xEDnea 229",
    y2: 60.958,
    transform: "translate(31.721)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_230",
    "data-name": "L\\xEDnea 230",
    x2: 63.441,
    transform: "translate(0 30.479)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_957",
    "data-name": "Grupo 957",
    transform: "translate(9.291 8.049)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_231",
    "data-name": "L\\xEDnea 231",
    x1: 43.104,
    y2: 43.104,
    transform: "translate(0.878 0.878)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_232",
    "data-name": "L\\xEDnea 232",
    x2: 44.86,
    y2: 44.86,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1716",
    "data-name": "Grupo 1716",
    transform: "translate(-4739.755 1887.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_861",
    "data-name": "Grupo 861",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_860",
    "data-name": "Grupo 860",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_859",
    "data-name": "Grupo 859",
    transform: "translate(-245.919 76.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_804",
    "data-name": "Trazado 804",
    d: "M860.39,409.615",
    transform: "translate(-580.559 -409.615)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_831",
    "data-name": "Grupo 831",
    transform: "translate(0 48.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_827",
    "data-name": "Grupo 827",
    transform: "translate(0 60.007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_725",
    "data-name": "Rect\\xE1ngulo 725",
    width: 281.718,
    height: 17.567,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_823",
    "data-name": "Grupo 823",
    transform: "translate(5.097 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_104",
    "data-name": "Elipse 104",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_105",
    "data-name": "Elipse 105",
    cx: 0.644,
    cy: 0.644,
    r: 0.644,
    transform: "translate(2.631 2.631)",
    fill: "#fffaf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_824",
    "data-name": "Grupo 824",
    transform: "translate(15.491 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_106",
    "data-name": "Elipse 106",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_162",
    "data-name": "L\\xEDnea 162",
    x2: 3.458,
    transform: "translate(1.546 3.275)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_826",
    "data-name": "Grupo 826",
    transform: "translate(25.885 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_107",
    "data-name": "Elipse 107",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_825",
    "data-name": "Grupo 825",
    transform: "translate(1.351 1.351)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_163",
    "data-name": "L\\xEDnea 163",
    y2: 3.848,
    transform: "translate(1.924)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_164",
    "data-name": "L\\xEDnea 164",
    x1: 3.848,
    transform: "translate(0 1.924)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_165",
    "data-name": "L\\xEDnea 165",
    y2: 131.607,
    transform: "translate(0 77.574)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_166",
    "data-name": "L\\xEDnea 166",
    y2: 51.825,
    transform: "translate(281.719 77.574)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_108",
    "data-name": "Elipse 108",
    cx: 23.846,
    cy: 23.846,
    r: 23.846,
    transform: "translate(18.933 102.374)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_726",
    "data-name": "Rect\\xE1ngulo 726",
    width: 87.117,
    height: 43.876,
    transform: "translate(43.097 126.537)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_828",
    "data-name": "Grupo 828",
    transform: "translate(142.931 132.896)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_167",
    "data-name": "L\\xEDnea 167",
    x2: 76.039,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_168",
    "data-name": "L\\xEDnea 168",
    x2: 76.039,
    transform: "translate(0 11.764)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_169",
    "data-name": "L\\xEDnea 169",
    x2: 42.922,
    transform: "translate(0 23.528)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_829",
    "data-name": "Grupo 829",
    transform: "translate(313.968 113.531)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_170",
    "data-name": "L\\xEDnea 170",
    x2: 9.413,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_171",
    "data-name": "L\\xEDnea 171",
    x2: 9.413,
    transform: "translate(0 4.899)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_172",
    "data-name": "L\\xEDnea 172",
    x2: 5.314,
    transform: "translate(0 9.798)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_830",
    "data-name": "Grupo 830",
    transform: "translate(11.938 199.664)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_109",
    "data-name": "Elipse 109",
    cx: 3.206,
    cy: 3.206,
    r: 3.206,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_110",
    "data-name": "Elipse 110",
    cx: 3.206,
    cy: 3.206,
    r: 3.206,
    transform: "translate(9.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_111",
    "data-name": "Elipse 111",
    cx: 3.206,
    cy: 3.206,
    r: 3.206,
    transform: "translate(19.977 0.247)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_112",
    "data-name": "Elipse 112",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(279.555 87.655)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_113",
    "data-name": "Elipse 113",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(86.916)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_173",
    "data-name": "L\\xEDnea 173",
    y1: 56.96,
    transform: "translate(89.757 3.047)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_727",
    "data-name": "Rect\\xE1ngulo 727",
    width: 114.156,
    height: 83.578,
    transform: "translate(173.552 189.58)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_728",
    "data-name": "Rect\\xE1ngulo 728",
    width: 43.828,
    height: 36.693,
    transform: "translate(114.945 192.128)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_839",
    "data-name": "Grupo 839",
    transform: "translate(238.25 13.142)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_119",
    "data-name": "Elipse 119",
    cx: 15.882,
    cy: 15.882,
    r: 15.882,
    transform: "translate(53.878)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_731",
    "data-name": "Rect\\xE1ngulo 731",
    width: 55.505,
    height: 68.569,
    transform: "translate(13.829 15.37)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_838",
    "data-name": "Grupo 838",
    transform: "translate(0 37.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_809",
    "data-name": "Trazado 809",
    d: "M827.593,515.385a25.542,25.542,0,0,1-15.839-5.525l7.733-9.727a12.9,12.9,0,0,0,8.106,2.824,13.04,13.04,0,0,0,7.286-23.855l6.957-10.3a25.468,25.468,0,0,1-14.242,46.579Z",
    transform: "translate(-811.754 -468.806)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1717",
    "data-name": "Grupo 1717",
    transform: "translate(-5615.696 1987.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_782",
    "data-name": "Grupo 782",
    transform: "translate(93.723 56.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_748",
    "data-name": "Trazado 748",
    d: "M233.385,516.336c-.032.914-.086,1.851-.157,2.819v.015a36.13,36.13,0,1,1-59.562-30.8l9.268-26.5-7.111-22.939a10.755,10.755,0,0,1,20.544-6.37l14.907,49.3c2.519-.056,8.8.126,8.8.126C220.495,482.169,234.567,488.335,233.385,516.336Z",
    transform: "translate(-161.125 -425)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_781",
    "data-name": "Grupo 781",
    transform: "translate(72.103 91.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_749",
    "data-name": "Trazado 749",
    d: "M245.619,531.833c-.008.945-.063,1.89-.157,2.82C245.533,533.684,245.588,532.747,245.619,531.833Z",
    transform: "translate(-245.462 -531.833)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_750",
    "data-name": "Trazado 750",
    d: "M214.729,513.7s-13.863,9.495-10.871,26.866",
    transform: "translate(-167.263 -437.866)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_751",
    "data-name": "Trazado 751",
    d: "M180.3,539.019s8.1-3.011,13.244-.356",
    transform: "translate(-163.907 -441.329)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_783",
    "data-name": "Grupo 783",
    transform: "translate(71.91 22.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_752",
    "data-name": "Trazado 752",
    d: "M218.354,417.351a41.689,41.689,0,0,1-5.877,31.585,17.823,17.823,0,0,0-3.009,9.964l.23,17.961-48.631,7.105-4.918-17.277a17.8,17.8,0,0,0-5.725-8.678,41.827,41.827,0,1,1,67.93-40.659Z",
    transform: "translate(-135.612 -384.254)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_753",
    "data-name": "Trazado 753",
    d: "M183.027,488.247l-11.313-44.241,0,.021s-2.253-9.706-6.916-7.356,1.465,15.744,19.031,13.177,18.789-17.034,13.648-17.951-4.522,9.026-4.522,9.026l0-.021,1.818,45.629",
    transform: "translate(-139.628 -391.157)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_721",
    "data-name": "Rect\\xE1ngulo 721",
    d: "M0,0H49.148a0,0,0,0,1,0,0V3.166a23.5,23.5,0,0,1-23.5,23.5H23.5A23.5,23.5,0,0,1,0,3.166V0A0,0,0,0,1,0,0Z",
    transform: "matrix(0.989, -0.145, 0.145, 0.989, 25.908, 102.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_754",
    "data-name": "Trazado 754",
    d: "M213.376,402.035a35.97,35.97,0,0,1,11.118,32.653",
    transform: "translate(-146.892 -386.834)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_755",
    "data-name": "Trazado 755",
    d: "M196.613,392.626a35.7,35.7,0,0,1,9.241,4.15",
    transform: "translate(-144.461 -385.469)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_784",
    "data-name": "Grupo 784",
    transform: "translate(89.788 126.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_756",
    "data-name": "Trazado 756",
    d: "M190.193,527.641a8.885,8.885,0,0,1-8.753,2.013l-18.683-5.849a8.887,8.887,0,0,1,5.311-16.963l18.683,5.849a8.89,8.89,0,0,1,3.442,14.949Z",
    transform: "translate(-156.523 -506.434)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_785",
    "data-name": "Grupo 785",
    transform: "translate(92.307 109.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_757",
    "data-name": "Trazado 757",
    d: "M193.139,507.413a8.883,8.883,0,0,1-8.753,2.013L165.7,503.577a8.887,8.887,0,0,1,5.311-16.963l18.684,5.849a8.889,8.889,0,0,1,3.441,14.949Z",
    transform: "translate(-159.469 -486.206)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_786",
    "data-name": "Grupo 786",
    transform: "translate(87.896 144.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_758",
    "data-name": "Trazado 758",
    d: "M183.41,548.124a8.875,8.875,0,0,1-7.865,1.423l-14.864-4.391a8.887,8.887,0,0,1,5.036-17.047l14.864,4.392a8.889,8.889,0,0,1,2.829,15.623Z",
    transform: "translate(-154.31 -527.743)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_787",
    "data-name": "Grupo 787",
    transform: "translate(121.208 113.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_759",
    "data-name": "Trazado 759",
    d: "M220.456,509.958,202,511.244c-4.055.283-7.912-3.572-8.615-8.608s2.016-9.347,6.071-9.633l23.135-1.612",
    transform: "translate(-193.274 -491.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_140",
    "data-name": "L\\xEDnea 140",
    x2: 5.442,
    transform: "translate(26.017 0.304)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_788",
    "data-name": "Grupo 788",
    transform: "translate(121.208 113.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_760",
    "data-name": "Trazado 760",
    d: "M221.449,510.511l-19.45.784c-4.055.283-7.912-3.572-8.615-8.608s2.016-9.347,6.071-9.633l19.835-1.308",
    transform: "translate(-193.274 -491.746)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_141",
    "data-name": "L\\xEDnea 141",
    x1: 3.058,
    y2: 11.045,
    transform: "translate(133.807 2.781)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_142",
    "data-name": "L\\xEDnea 142",
    y1: 20.828,
    x2: 19.453,
    transform: "translate(143.413)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_143",
    "data-name": "L\\xEDnea 143",
    x2: 4.623,
    y2: 10.487,
    transform: "translate(67.083 21.646)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_144",
    "data-name": "L\\xEDnea 144",
    x1: 22.259,
    y1: 17.797,
    transform: "translate(40.954 22.653)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_761",
    "data-name": "Trazado 761",
    d: "M214.29,582.5c17.1,55.571,10.522,65.629-31.633,88.059-27.821,14.8-5.985,57.281,0,67.54",
    transform: "translate(-68.523 -390.994)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 45
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_96",
    "data-name": "Elipse 96",
    cx: 113.707,
    cy: 18.809,
    rx: 113.707,
    ry: 18.809,
    transform: "translate(0 330.434)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Great_Idea",
    "data-name": "Great Idea",
    transform: "translate(-5590.458 1937.35) rotate(-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1346",
    "data-name": "Trazado 1346",
    d: "M3.35,2.565a6.024,6.024,0,0,0,.063.728c.03.152.107.327.324.3.143-.018.287-.092.293-.242.026-.667.625-.855,1.008-1.208A4.349,4.349,0,0,1,10.215,1.4a1.527,1.527,0,0,1,.958,1.4c.008.18-.009.424.223.482s.32-.171.446-.3a1.045,1.045,0,0,0,.289-.394C12.6.82,14.119,1,15.418.882a33.112,33.112,0,0,1,5.352.1,1.382,1.382,0,0,1,.224.034c-.063.75.881,1.145.71,1.889-.154.672-.809.684-1.353.861a11.9,11.9,0,0,1-4.215.722c-.419-.018-.718.3-.855.759a8.914,8.914,0,0,0-.132,1.7.514.514,0,0,0,.459.589c.8.1,1.638.581,2.356-.237a.582.582,0,0,1,.693-.089,2.03,2.03,0,0,1,1.382,1.482,1.862,1.862,0,0,1-1.006,1.984,5.283,5.283,0,0,1-2.529.782c-.164,0-.378.04-.384.229-.019.558.489.82.753,1.221a.565.565,0,0,0,.793.194,1.87,1.87,0,0,1,2.438.326c.826.792.966,1.477.114,2.2a4.5,4.5,0,0,1-2.9,1.349,1.871,1.871,0,0,1-1.364-.422,8.416,8.416,0,0,1-2.559-3.306,9.8,9.8,0,0,0-1.61-3.271c-.348-.412-.5-.46-.88.087a64.081,64.081,0,0,1-4.534,6.058.775.775,0,0,1-.969.206c-.7-.365-1.4-.759-1.537-1.667-.048-.307-.014-.73-.4-.831-.334-.088-.5.289-.706.481a1.388,1.388,0,0,1-2.218-.261,3.025,3.025,0,0,1-.522-2.155,39.231,39.231,0,0,0,.587-5.6A51.092,51.092,0,0,1,.865.678c.053-.711.4-.756.922-.612A2.389,2.389,0,0,1,3.35,2.565Zm4.884,1.7c0-.581-.155-.7-.587-.471a4.639,4.639,0,0,0-1.5,1.212,10.756,10.756,0,0,0-2.593,7.324c.01.207-.167.572.159.643s.429-.295.526-.525c.8-1.909,2.2-3.468,3.078-5.337A14.038,14.038,0,0,0,8.233,4.265Z",
    transform: "translate(15.115 30.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1347",
    "data-name": "Trazado 1347",
    d: "M.081,15.192a21.013,21.013,0,0,1,.885-5.5A25.727,25.727,0,0,1,2.565,4.4q.642-1.432,1.263-2.872A2.234,2.234,0,0,1,7.2.4c1.564.955,1.793,2.487,2.419,3.893.952,2.136,1.344,4.451,2.153,6.633a2.6,2.6,0,0,0,1.781,1.635,3.407,3.407,0,0,1,1.612,1.186,1.125,1.125,0,0,1-.428,1.774c-.073.034-.157.045-.234.074a5.923,5.923,0,0,0-2.7,1.978,1.891,1.891,0,0,1-2.509.314,36.941,36.941,0,0,1-3.919-2.866c-.41-.291-.839-.865-1.32-.636-.523.249-.384.922-.364,1.476a2.329,2.329,0,0,1-.8,1.995,1.691,1.691,0,0,1-1.8.446A1.909,1.909,0,0,1,0,16.5,12.556,12.556,0,0,1,.081,15.192ZM7.744,10.85c.7.1.966-.067.711-.838A46.536,46.536,0,0,0,6.8,5.184c-.1-.211-.131-.548-.421-.541a.746.746,0,0,0-.6.505A14.394,14.394,0,0,0,4.609,9.941c-.008.385.121.517.467.613A26.551,26.551,0,0,0,7.744,10.85Z",
    transform: "translate(40.47 28.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1348",
    "data-name": "Trazado 1348",
    d: "M0,14.42c.42-2.17.377-4.5.941-6.738.417-1.658.8-3.325,1.288-4.963.378-1.277.673-1.541,1.835-1.467A1.763,1.763,0,0,0,5.409.438,1.174,1.174,0,0,1,6.3,0,3.109,3.109,0,0,1,8.862,1.709a58.2,58.2,0,0,1,2.273,7.167.923.923,0,0,0,1.011.834,5.851,5.851,0,0,1,2.494.313c.291.149.609.267.542.7a.766.766,0,0,1-.678.716c-.817.082-1.385.7-2.141.913-.489.138-.45.589-.479,1.014a2.822,2.822,0,0,1-1.175,2.349,1.079,1.079,0,0,1-1.6-.149c-.8-1.021-1.917-1.7-2.756-2.662a2.356,2.356,0,0,0-1.616-.659.386.386,0,0,0-.477.337,13.123,13.123,0,0,0-.621,2.6c-.006.9-.628,1.407-1.185,1.961a.587.587,0,0,1-.688.073A2.924,2.924,0,0,1,0,14.42ZM5.084,7.89c0,.456.042.895.6.909a9.838,9.838,0,0,1,1.6.3c.8.153,1.028-.063.782-.861C7.679,7,7.233,5.78,6.8,4.557c-.11-.312-.252-.489-.546-.091C5.494,5.494,5.514,6.769,5.084,7.89Z",
    transform: "translate(38.924 2.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1349",
    "data-name": "Trazado 1349",
    d: "M9.347,4.167A5.177,5.177,0,0,1,7.427,8.29c-.655.58-1.132,1.407-2.172,1.463-.332.018-.343.357-.166.644,1.127,1.829,2.24,3.667,3.38,5.489.4.642.8.637,1.277.041.154-.192.274-.411.435-.595.187-.214.321-.571.7-.432a.758.758,0,0,1,.514.849c-.254,1.172-.135,2.46-1.008,3.455a1.315,1.315,0,0,1-1.794.156c-1.219-.775-2.557-1.406-3.3-2.823-.332-.633-.716-1.262-1.062-1.9-.1-.183-.181-.463-.448-.379-.22.07-.118.321-.124.508a14.369,14.369,0,0,1-.092,1.631A1.2,1.2,0,0,1,2.44,17.405a1.808,1.808,0,0,1-1.6-.766c-.786-.82-.591-1.9-.694-2.852a28.908,28.908,0,0,1,.1-6.576,8.063,8.063,0,0,0,.032-1.8A9.93,9.93,0,0,1,1.048.879C1.4-.081,1.826-.249,2.619.346A2.131,2.131,0,0,0,4.56.72a4.169,4.169,0,0,1,3.914.849A3.4,3.4,0,0,1,9.347,4.167ZM6.5,4.074a.483.483,0,0,0-.556-.5,1.678,1.678,0,0,0-1.555.87,21.894,21.894,0,0,0-.748,2.067.467.467,0,0,0,.071.538c.178.157.377.03.519-.081A11.152,11.152,0,0,0,6.4,4.761C6.506,4.615,6.525,4.465,6.5,4.074Z",
    transform: "translate(16.706 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1350",
    "data-name": "Trazado 1350",
    d: "M3.26,8.938a.351.351,0,0,0,.339-.2c.617-.99,1.519-.9,2.505-.759a67.891,67.891,0,0,0,7.521.782,2.769,2.769,0,0,1,1.466.4,1.606,1.606,0,0,1,0,2.867,1.706,1.706,0,0,1-1.877.239,9.959,9.959,0,0,0-2.284-.563c-.5-.127-.658.1-.469.5a4.472,4.472,0,0,1-.083,3.039c-.256,1.143-1.374,1.525-2.321,1.983a9.3,9.3,0,0,1-1.015.29,3.331,3.331,0,0,1-3.986-1.1,16.831,16.831,0,0,1-2.024-2.829A8.548,8.548,0,0,1,0,9.538,16.74,16.74,0,0,1,1.266,3.529,7.166,7.166,0,0,1,4.023.2,2.166,2.166,0,0,1,6,.284a.85.85,0,0,1-.054,1.48A3.2,3.2,0,0,0,4.656,3.68a7.148,7.148,0,0,1-.447.765A15.67,15.67,0,0,0,3.082,8.181.788.788,0,0,0,3.26,8.938Zm.034.994c-.621.994.127,1.769.5,2.533.733,1.495,1.6,2.28,3.316,1.624a.744.744,0,0,0,.526-.783,2.187,2.187,0,0,0-2.106-2.051,1.843,1.843,0,0,1-1.868-1.033C3.592,10.088,3.5,9.934,3.294,9.933Z",
    transform: "translate(0 0.911)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1351",
    "data-name": "Trazado 1351",
    d: "M3.735.122C5.082-.2,6.638.2,8.206.346c.549.05.99.308,1.01.862s-.37.819-.938,1.039a19.125,19.125,0,0,1-3.637,1c-.49.086-.647.553-.667,1.016a14.915,14.915,0,0,1,.1,2.678c-.1.45.438.378.655.242.7-.436,1.155-.145,1.494.437a1.536,1.536,0,0,1-.237,2.015c-.453.294-.693.76-1.093,1.088s-.135.728,0,1.037a13.971,13.971,0,0,0,.971,1.8c.373.6.822.953,1.619.569.455-.218,1.118-.41,1.386.325.237.65.832,1.214.028,2.035-1.549,1.582-3.334,1.5-4.85-.115A9.367,9.367,0,0,1,1.6,12.286C1.255,10.9.566,9.675.112,8.347c-.147-.429-.178-.935.079-1.164.718-.642.45-1.466.554-2.208C.854,4.2.819,3.4.883,2.613,1.027.817,1.724.162,3.735.122Z",
    transform: "translate(27.721 2.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1352",
    "data-name": "Trazado 1352",
    d: "M2.889.081c2.273-.347,4.419.5,6.608,1a7.956,7.956,0,0,1,2.783,1.29,1.539,1.539,0,0,1,.642,1.855,2.045,2.045,0,0,1-2.284.566,8.58,8.58,0,0,0-2.526-.61c-.438-.061-.666.054-.587.643.241,1.808-.173,3.616-.089,5.432a24.773,24.773,0,0,0,.319,4.791A1.792,1.792,0,0,1,7.14,16.8a1.28,1.28,0,0,1-1.635.315,1.991,1.991,0,0,1-1.05-1.71,41.659,41.659,0,0,0-.793-7.431,1.657,1.657,0,0,1,.314-1.235c.6-.885.177-1.83.267-2.735.059-.595-.509-.495-.915-.465A3.007,3.007,0,0,1,.179,1.83,1.031,1.031,0,0,1,1.063.189,4.679,4.679,0,0,1,2.889.081Z",
    transform: "translate(52.211 1.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1353",
    "data-name": "Trazado 1353",
    d: "M3.149,2.662c.075,1.48-.012,3.271-.061,5.063A3.279,3.279,0,0,0,3.3,9.093a2.865,2.865,0,0,1-.862,3.444.887.887,0,0,1-1.263.05A3.257,3.257,0,0,1,.046,10.5C-.144,7.36.314,4.24.315,1.108.316.228.788-.1,1.65.027,3.144.248,3.207.345,3.149,2.662Z",
    transform: "translate(7.963 33.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1354",
    "data-name": "Trazado 1354",
    d: "M1.729,0A1.42,1.42,0,0,1,3.059,1.61,3.81,3.81,0,0,1,2.4,3.251c-.264.371-.524.715-1.047.565S.322,3.456.226,2.8c-.051-.347-.16-.687-.2-1.035C-.123.5.376-.008,1.729,0Z",
    transform: "translate(10.832 28.439)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1718",
    "data-name": "Grupo 1718",
    transform: "translate(-5405.978 1911.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_764",
    "data-name": "Trazado 764",
    d: "M456.6,476.21l-44.8,13.68a1.957,1.957,0,0,1-2.282-1.276l-12.149-28.819a2.049,2.049,0,0,1,1.029-2.828l50.164-15.317a2.038,2.038,0,0,1,2.419,1.708l6.787,30.456A1.969,1.969,0,0,1,456.6,476.21Z",
    transform: "translate(-282.446 -221.626)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_802",
    "data-name": "Grupo 802"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_145",
    "data-name": "L\\xEDnea 145",
    x1: 17.956,
    y2: 30.237,
    transform: "translate(88.899 179.16)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98",
    "data-name": "Elipse 98",
    cx: 45.154,
    cy: 45.154,
    r: 45.154,
    transform: "translate(116.894)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_793",
    "data-name": "Grupo 793",
    transform: "translate(100.996 34.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_791",
    "data-name": "Grupo 791"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_146",
    "data-name": "L\\xEDnea 146",
    y2: 71.806,
    transform: "translate(37.366)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_147",
    "data-name": "L\\xEDnea 147",
    x2: 74.731,
    transform: "translate(0 35.903)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_792",
    "data-name": "Grupo 792",
    transform: "translate(10.944 9.482)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_148",
    "data-name": "L\\xEDnea 148",
    x1: 50.775,
    y2: 50.775,
    transform: "translate(1.034 1.034)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_149",
    "data-name": "L\\xEDnea 149",
    x2: 52.843,
    y2: 52.843,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_794",
    "data-name": "Grupo 794",
    transform: "translate(0 37.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_765",
    "data-name": "Trazado 765",
    d: "M346.594,353.845c-30.22,8.232-63.241-7.052-77.233-37.387s-4.181-65.375,21.7-83.017",
    transform: "translate(-262.981 -228.842)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_99",
    "data-name": "Elipse 99",
    cx: 10.516,
    cy: 66.528,
    rx: 10.516,
    ry: 66.528,
    transform: "matrix(0.908, -0.419, 0.419, 0.908, 18.399, 8.809)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_722",
    "data-name": "Rect\\xE1ngulo 722",
    d: "M0,0H52.392a0,0,0,0,1,0,0V4.925a23.5,23.5,0,0,1-23.5,23.5H23.5A23.5,23.5,0,0,1,0,4.925V0A0,0,0,0,1,0,0Z",
    transform: "matrix(0.926, -0.378, 0.378, 0.926, 186.152, 196.246)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_795",
    "data-name": "Grupo 795",
    transform: "translate(133.437 107.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_766",
    "data-name": "Trazado 766",
    d: "M469.7,354.453c5.089-13.4-2.805-23.768-8.27-21.146-7.188,3.448-.162,12.349,2.426,15.194,2.511,2.759,7.919,6.017,11.993,6.68,1.822.3,9.406-.339,11.185-11.27,4.354-26.75,3.954-36.594-3.234-33.145s2.45,15.218,2.45,15.218l-.023-.023a137.135,137.135,0,0,0,15.114,14.095",
    transform: "translate(-424.748 -310.102)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_767",
    "data-name": "Trazado 767",
    d: "M464.008,361.978a36.965,36.965,0,0,1-9.166,13.27c-19.474,18.85-39.015,7.723-35.334.651s17.225,1.4,17.225,1.4,23.035,12.443,19.623,38.488",
    transform: "translate(-419.059 -317.627)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_100",
    "data-name": "Elipse 100",
    cx: 8.773,
    cy: 8.773,
    r: 8.773,
    transform: "translate(93.904 91.219)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_797",
    "data-name": "Grupo 797",
    transform: "translate(26.35 36.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_796",
    "data-name": "Grupo 796",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_768",
    "data-name": "Trazado 768",
    d: "M339.662,253.193a32.476,32.476,0,1,1-38.351,52.362",
    transform: "translate(-294.891 -230.768)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 23
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_801",
    "data-name": "Grupo 801",
    transform: "translate(199.505 36.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_798",
    "data-name": "Grupo 798",
    transform: "translate(21.519 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_770",
    "data-name": "Trazado 770",
    d: "M576.1,230.715a70.119,70.119,0,0,1-41.9,131.9",
    transform: "translate(-523.349 -227.062)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_101",
    "data-name": "Elipse 101",
    cx: 69.439,
    cy: 11.351,
    rx: 69.439,
    ry: 11.351,
    transform: "translate(0 132.361) rotate(-72.379)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_800",
    "data-name": "Grupo 800",
    transform: "translate(0 3.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_799",
    "data-name": "Grupo 799",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_771",
    "data-name": "Trazado 771",
    d: "M552.856,267.047a33.386,33.386,0,0,1-19.566,63.536",
    transform: "translate(-501.697 -235.646)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_102",
    "data-name": "Elipse 102",
    cx: 33.158,
    cy: 5.286,
    rx: 33.158,
    ry: 5.286,
    transform: "translate(25.984 93.155) rotate(-72.379)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_773",
    "data-name": "Trazado 773",
    d: "M579.077,234.524c2.019,9.34-2.766,35.9-12.372,66.143-9.432,29.7-20.611,53.81-27.676,60.79",
    transform: "translate(-502.529 -227.614)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_103",
    "data-name": "Elipse 103",
    cx: 10.572,
    cy: 10.572,
    r: 10.572,
    transform: "translate(23.16 53.567)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1719",
    "data-name": "Grupo 1719",
    transform: "translate(-5212.978 1866.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_779",
    "data-name": "Trazado 779",
    d: "M509.088,142.654c-5.678,6.05-14.931,17.827-7.662,26.046,5.193,5.873,14.672,3.277,19.819-1.087,6.565-5.566,10.467-17.921,5.625-25.649-4.169-6.654-13.668-6.333-20.276-4.494-7.388,2.055-15.36,7.2-17.42,15.023-2.355,8.94,4.991,16.742,13.8,16.053,9.522-.746,19.8-8.483,23.263-17.36,3.545-9.1-1.814-17.967-11.362-19.428-12.544-1.918-30.231,8.785-22.345,22.881a.856.856,0,0,0,1.477-.863c-6.272-11.213,5.888-19.519,15.975-20.451,5.076-.468,10.566.928,13.654,5.239,3.4,4.753,2.168,10.629-.684,15.266-4.86,7.9-19.608,18.164-28.564,10.688-3.793-3.168-4.7-8.867-3.01-13.307,1.561-4.107,5.332-7.168,9.015-9.3,6.014-3.482,14.628-5.57,21.183-2.393,8.412,4.075,5.94,16.086,2.135,22.51-3.713,6.27-12.475,10.908-19.385,6.857-9.945-5.829,1.27-20.013,5.967-25.018.755-.8-.453-2.015-1.21-1.21Z",
    transform: "translate(-488.73 -131.535)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1720",
    "data-name": "Grupo 1720",
    transform: "translate(-5284.979 2130.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_820",
    "data-name": "Grupo 820",
    transform: "translate(15.654 17.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_803",
    "data-name": "Trazado 803",
    d: "M451.287,466.072C434.226,463.495,423.57,489.821,440.95,497c12.259,5.06,37.076-.059,36.886-16.714-.1-8.714-7.178-15.61-14.973-18.226-8.484-2.849-18.307-1.427-26.222,2.445-7.548,3.694-15.123,11.767-13.631,20.78,1.442,8.707,11.5,13.221,19.245,14.307a30.494,30.494,0,0,0,13.706-1.441,52.045,52.045,0,0,0,14.326-6.652c3.86-2.717,6.989-6.718,7.447-11.555.509-5.39-2.124-9.908-6.221-13.229-7.69-6.239-17.582-6.017-26.382-2.485-7.646,3.067-15.244,9.237-16.264,17.893-1.023,8.683,5.848,16.391,14.247,17.374,9.286,1.087,19.011-2.911,26.4-8.3,5.8-4.229,12.13-11.86,9.368-19.512-2.437-6.761-10.72-9.559-17.162-10.423-11.561-1.552-23.98,3.38-27.4,15.376a.634.634,0,0,0,1.221.337c3.147-11.054,14.049-15.373,24.65-14.6,7.168.518,17.541,4.065,18.09,12.583.3,4.636-2.867,9.111-5.97,12.227a40.045,40.045,0,0,1-11.985,7.871c-8.66,3.913-21.422,6.05-27.622-3.065-6.488-9.534.162-19.522,8.739-24.556,9.318-5.466,20.985-6.463,29.716.619,5.322,4.315,6.943,11.216,3.455,17.231-2.929,5.053-9.056,7.923-14.256,9.984-4.819,1.908-9.733,3.428-14.959,3.326a27.828,27.828,0,0,1-14.491-4.435c-3.974-2.585-6.873-6.675-6.851-11.528.021-5.39,3.941-10.36,7.9-13.639,7.477-6.2,18.546-8.37,27.937-6.416,9.159,1.9,18.19,10.205,16.492,20.329-1.47,8.767-11.671,12.923-19.368,14.242-8.883,1.523-21.35-.23-23.59-10.688-2.155-10.044,7.345-20.695,17.529-19.155.8.121,1.141-1.1.336-1.22Z",
    transform: "translate(-422.821 -460.554)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_150",
    "data-name": "L\\xEDnea 150",
    y1: 14.571,
    x2: 8.429,
    transform: "translate(64.532)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_151",
    "data-name": "L\\xEDnea 151",
    y1: 4.65,
    x2: 9.3,
    transform: "translate(71.799 12.787)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_152",
    "data-name": "L\\xEDnea 152",
    x1: 15.654,
    y2: 13.474,
    transform: "translate(0 57.338)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_153",
    "data-name": "L\\xEDnea 153",
    x1: 1.584,
    y2: 15.047,
    transform: "translate(23.175 57.338)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_154",
    "data-name": "L\\xEDnea 154",
    x2: 8.137,
    y2: 15.112,
    transform: "translate(65.986 52.312)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_155",
    "data-name": "L\\xEDnea 155",
    x2: 9.3,
    y2: 3.643,
    transform: "translate(71.799 48.67)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_156",
    "data-name": "L\\xEDnea 156",
    y1: 1.162,
    x2: 6.975,
    transform: "translate(75.286 43.012)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1721",
    "data-name": "Grupo 1721",
    transform: "translate(-5198.579 1875.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_849",
    "data-name": "Trazado 849",
    d: "M512.328,159.323a.83.83,0,0,1,.275.37,1.085,1.085,0,0,1-.151.9,1.324,1.324,0,0,1-.677.646,1.515,1.515,0,0,1-1.683-.637q-.532-.6-.235-1.085c.154-.228.554-.389,1.2-.48A1.554,1.554,0,0,1,512.328,159.323Zm.043-16.6a6.258,6.258,0,0,1,.683,1.365,8.961,8.961,0,0,1,.051,4.886q-.623,2.467-1.22,4.924-.085.759-.168,1.518a1.514,1.514,0,0,1-.782,1.179q-1.271.623-1.429.007-.521-2.066.525-6.2a15.082,15.082,0,0,0,.63-6.147,1.1,1.1,0,0,0-.407-.66.706.706,0,0,0-.711-.115q-.339.118-.675.82-.191.623-.65,1.892a5.5,5.5,0,0,0,.044,1.62.9.9,0,0,1-.75,1.109,1.248,1.248,0,0,1-1.586-.61,3.589,3.589,0,0,1-.172-.407,3.912,3.912,0,0,1,.148-2.738,15.581,15.581,0,0,1,1.329-2.451,2.734,2.734,0,0,1,1.435-1.234,3.6,3.6,0,0,1,2.073,0A2.813,2.813,0,0,1,512.371,142.728Z",
    transform: "translate(-505.571 -141.337)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1722",
    "data-name": "Grupo 1722",
    transform: "translate(-5163.932 1896.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_868",
    "data-name": "Trazado 868",
    d: "M565.832,226.224c-3.563-33.064-38.171-39.946-38.171-39.946",
    transform: "translate(-526.085 -183.417)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_976",
    "data-name": "Grupo 976",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_869",
    "data-name": "Trazado 869",
    d: "M533.668,183l-7.446,1.975a.522.522,0,0,0-.228.864,48.965,48.965,0,0,1,6.746,8.545c.352.564,1.246.045.893-.522a50.194,50.194,0,0,0-6.907-8.755l-.229.864L533.943,184a.518.518,0,0,0-.275-1Z",
    transform: "translate(-525.847 -182.984)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1723",
    "data-name": "Grupo 1723",
    transform: "translate(-5386.297 1843.749) rotate(47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_866",
    "data-name": "Trazado 866",
    d: "M9.227,112.818C-32.462-.089,80.632,0,80.632,0",
    transform: "translate(0 4.672)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_974",
    "data-name": "Grupo 974",
    transform: "translate(71.23 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_867",
    "data-name": "Trazado 867",
    d: "M3.229.983,9.6,5.321V4.428A50.165,50.165,0,0,0,.177,10.4c-.519.416.216,1.144.731.731a48.959,48.959,0,0,1,9.209-5.809.522.522,0,0,0,0-.893L3.751.09C3.2-.286,2.681.61,3.229.983Z",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1724",
    "data-name": "Grupo 1724",
    transform: "translate(-5090.957 1946.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_816",
    "data-name": "Grupo 816",
    transform: "translate(430.099 108.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_815",
    "data-name": "Grupo 815",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_813",
    "data-name": "Grupo 813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_791",
    "data-name": "Trazado 791",
    d: "M925.6,519.428l-.345,21.592A126.03,126.03,0,0,1,922.568,517c22.643,2.867,45.652,1.68,68.481.488a399.563,399.563,0,0,1-69.743,3.8",
    transform: "translate(-915.387 -515.89)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_792",
    "data-name": "Trazado 792",
    d: "M988.181,517.491l-.2,23.21a248.051,248.051,0,0,1-1.806-25l11.818,24.747c-2.794.957-5.887.805-8.872.64l-74.736-4.13,75.178-1.185L937.78,539",
    transform: "translate(-914.383 -515.701)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_793",
    "data-name": "Trazado 793",
    d: "M925.838,549.421h72.351",
    transform: "translate(-916.044 -520.592)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_794",
    "data-name": "Trazado 794",
    d: "M934.192,545.44l58.39,1.052",
    transform: "translate(-917.256 -520.015)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_795",
    "data-name": "Trazado 795",
    d: "M1003.2,518.137q.232,9.6-.133,19.192",
    transform: "translate(-927.247 -516.054)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_796",
    "data-name": "Trazado 796",
    d: "M1005.167,519.837q-.267,10.612.231,21.225",
    transform: "translate(-927.539 -516.301)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_814",
    "data-name": "Grupo 814",
    transform: "translate(36.002 8.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_797",
    "data-name": "Trazado 797",
    d: "M960.872,529.645a6.124,6.124,0,0,0-.377,1.779q-.055.917-.1,1.834c-.014.18-.132.269-.356.269a.528.528,0,0,1-.184-.032.718.718,0,0,1-.463-.723,3.578,3.578,0,0,1,.044-.458,3.7,3.7,0,0,0,.043-.447q.043-.313.108-.939a4.887,4.887,0,0,1-1.683,1.046.824.824,0,0,1-.259.043,1.168,1.168,0,0,1-.916-.561,1.245,1.245,0,0,1-.237-.776,3.083,3.083,0,0,1,.184-.96A11.869,11.869,0,0,1,958.5,526.3q.626-.83,1.111-.83c.287,0,.45.108.485.323a.339.339,0,0,1-.184.389q-.377.205-.4.226A10.736,10.736,0,0,0,957.852,529a4.2,4.2,0,0,0-.463,1.758c0,.093,0,.187.01.28a.279.279,0,0,1,.065.1c.029.061.068.081.119.06a9.437,9.437,0,0,0,2.146-1.478,1.24,1.24,0,0,0,.248-.5.393.393,0,0,1,.389-.3c-.058,0,0-.008.172-.022.086-.014.144,0,.173.044a.964.964,0,0,1,.205.5A.548.548,0,0,1,960.872,529.645Z",
    transform: "translate(-956.494 -525.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_798",
    "data-name": "Trazado 798",
    d: "M966.1,530.3a2.675,2.675,0,0,1-1.8,1.7,1.262,1.262,0,0,1-.28.032,1.756,1.756,0,0,1-1.24-.669,1.66,1.66,0,0,1-.421-1.176,3.757,3.757,0,0,1,.475-1.715,2.62,2.62,0,0,1,.5-.669.937.937,0,0,1,.636-.334.484.484,0,0,1,.323.13,3.014,3.014,0,0,0,.809.345,1.216,1.216,0,0,1,.734.582,2.793,2.793,0,0,1,.378,1.24A1.253,1.253,0,0,1,966.1,530.3Zm-.863-.669c-.05-.525-.19-.838-.421-.939a.277.277,0,0,0-.1-.021c-.086,0-.194.073-.324.215a1.029,1.029,0,0,1-.334.292c-.051.021-.122,0-.216-.065a.5.5,0,0,0-.183-.1.076.076,0,0,0-.054.022,1.248,1.248,0,0,0-.378,1,1.388,1.388,0,0,0,.216.787c.2.295.37.442.507.442a1.2,1.2,0,0,0,.917-.593A1.494,1.494,0,0,0,965.238,529.634Z",
    transform: "translate(-957.344 -525.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_799",
    "data-name": "Trazado 799",
    d: "M968.661,532.576a.533.533,0,0,1-.043.3c-.044.1-.1.147-.157.15a.2.2,0,0,0-.134.049.09.09,0,0,1-.087.032q-.572-.215-.647-.561c-.021-.1.047-.2.205-.308a.657.657,0,0,1,.334-.145.7.7,0,0,1,.339.151A.469.469,0,0,1,968.661,532.576ZM969.708,526a21.161,21.161,0,0,1-.55,2.718,10.822,10.822,0,0,0-.388,2.793.223.223,0,0,1-.113.178.267.267,0,0,1-.211.06c-.366-.072-.56-.252-.582-.539-.007-.151-.01-.3-.01-.453a11.863,11.863,0,0,1,.323-2.48q.5-2.167.54-2.46a.234.234,0,0,1,.161-.183.389.389,0,0,1,.27-.01l.366.108A.266.266,0,0,1,969.708,526Z",
    transform: "translate(-958.104 -525.49)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_945",
    "data-name": "Grupo 945",
    transform: "translate(104.109 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1714",
    "data-name": "Grupo 1714",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_943",
    "data-name": "Grupo 943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_931",
    "data-name": "Grupo 931",
    transform: "translate(0 66.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_927",
    "data-name": "Grupo 927",
    transform: "translate(0 60.007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_786",
    "data-name": "Rect\\xE1ngulo 786",
    width: 281.718,
    height: 17.567,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_923",
    "data-name": "Grupo 923",
    transform: "translate(5.097 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_151",
    "data-name": "Elipse 151",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_152",
    "data-name": "Elipse 152",
    cx: 0.644,
    cy: 0.644,
    r: 0.644,
    transform: "translate(2.631 2.631)",
    fill: "#fffaf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_924",
    "data-name": "Grupo 924",
    transform: "translate(15.491 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_153",
    "data-name": "Elipse 153",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_201",
    "data-name": "L\\xEDnea 201",
    x2: 3.458,
    transform: "translate(1.546 3.275)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_926",
    "data-name": "Grupo 926",
    transform: "translate(25.885 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_154",
    "data-name": "Elipse 154",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_925",
    "data-name": "Grupo 925",
    transform: "translate(1.351 1.351)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_202",
    "data-name": "L\\xEDnea 202",
    y2: 3.848,
    transform: "translate(1.924)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_203",
    "data-name": "L\\xEDnea 203",
    x1: 3.848,
    transform: "translate(0 1.924)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_204",
    "data-name": "L\\xEDnea 204",
    y2: 131.607,
    transform: "translate(0 77.574)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_205",
    "data-name": "L\\xEDnea 205",
    y2: 51.825,
    transform: "translate(281.718 77.574)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_155",
    "data-name": "Elipse 155",
    cx: 23.846,
    cy: 23.846,
    r: 23.846,
    transform: "translate(18.933 102.374)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_787",
    "data-name": "Rect\\xE1ngulo 787",
    width: 87.117,
    height: 43.876,
    transform: "translate(43.097 126.537)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_928",
    "data-name": "Grupo 928",
    transform: "translate(142.931 132.896)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_206",
    "data-name": "L\\xEDnea 206",
    x2: 76.039,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_207",
    "data-name": "L\\xEDnea 207",
    x2: 76.039,
    transform: "translate(0 11.764)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_208",
    "data-name": "L\\xEDnea 208",
    x2: 42.922,
    transform: "translate(0 23.528)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_930",
    "data-name": "Grupo 930",
    transform: "translate(243.308 174.183)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_156",
    "data-name": "Elipse 156",
    cx: 2.794,
    cy: 2.794,
    r: 2.794,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_157",
    "data-name": "Elipse 157",
    cx: 2.794,
    cy: 2.794,
    r: 2.794,
    transform: "translate(8.704)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_158",
    "data-name": "Elipse 158",
    cx: 2.794,
    cy: 2.794,
    r: 2.794,
    transform: "translate(17.408 0.215)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_159",
    "data-name": "Elipse 159",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(279.555 87.655)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_160",
    "data-name": "Elipse 160",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(86.916)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_161",
    "data-name": "Elipse 161",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(86.916 57.078)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_212",
    "data-name": "L\\xEDnea 212",
    y1: 56.96,
    transform: "translate(89.757 3.047)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_788",
    "data-name": "Rect\\xE1ngulo 788",
    width: 114.156,
    height: 83.578,
    transform: "translate(173.552 189.58)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_213",
    "data-name": "L\\xEDnea 213",
    y1: 0.17,
    x2: 46.367,
    transform: "translate(283.999 89.716)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_789",
    "data-name": "Rect\\xE1ngulo 789",
    width: 43.828,
    height: 36.693,
    transform: "translate(114.945 192.128)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_936",
    "data-name": "Grupo 936",
    transform: "translate(226.309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_790",
    "data-name": "Rect\\xE1ngulo 790",
    width: 281.719,
    height: 17.567,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_932",
    "data-name": "Grupo 932",
    transform: "translate(5.097 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_165",
    "data-name": "Elipse 165",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_166",
    "data-name": "Elipse 166",
    cx: 0.644,
    cy: 0.644,
    r: 0.644,
    transform: "translate(2.631 2.631)",
    fill: "#fffaf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_933",
    "data-name": "Grupo 933",
    transform: "translate(15.491 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_167",
    "data-name": "Elipse 167",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_215",
    "data-name": "L\\xEDnea 215",
    x2: 3.458,
    transform: "translate(1.546 3.275)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_935",
    "data-name": "Grupo 935",
    transform: "translate(25.885 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_168",
    "data-name": "Elipse 168",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_934",
    "data-name": "Grupo 934",
    transform: "translate(1.351 1.351)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_216",
    "data-name": "L\\xEDnea 216",
    y2: 3.848,
    transform: "translate(1.924)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_217",
    "data-name": "L\\xEDnea 217",
    x1: 3.848,
    transform: "translate(0 1.924)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_218",
    "data-name": "L\\xEDnea 218",
    y2: 51.825,
    transform: "translate(508.027 17.567)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_937",
    "data-name": "Grupo 937",
    transform: "translate(332.555 72.889)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_219",
    "data-name": "L\\xEDnea 219",
    x2: 112.724,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_220",
    "data-name": "L\\xEDnea 220",
    x2: 112.724,
    transform: "translate(0 11.764)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_221",
    "data-name": "L\\xEDnea 221",
    x2: 63.631,
    transform: "translate(0 23.528)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_939",
    "data-name": "Grupo 939",
    transform: "translate(238.25 30.775)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_169",
    "data-name": "Elipse 169",
    cx: 15.882,
    cy: 15.882,
    r: 15.882,
    transform: "translate(53.878)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_792",
    "data-name": "Rect\\xE1ngulo 792",
    width: 55.505,
    height: 68.569,
    transform: "translate(13.829 15.37)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_938",
    "data-name": "Grupo 938",
    transform: "translate(0 37.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_845",
    "data-name": "Trazado 845",
    d: "M827.593,515.385a25.542,25.542,0,0,1-15.839-5.525l7.733-9.727a12.9,12.9,0,0,0,8.106,2.824,13.04,13.04,0,0,0,7.286-23.855l6.957-10.3a25.468,25.468,0,0,1-14.242,46.579Z",
    transform: "translate(-811.754 -468.806)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_941",
    "data-name": "Grupo 941",
    transform: "translate(431.697 71.755)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_170",
    "data-name": "Elipse 170",
    cx: 15.882,
    cy: 15.882,
    r: 15.882,
    transform: "translate(52.26 53.878)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_793",
    "data-name": "Rect\\xE1ngulo 793",
    width: 55.505,
    height: 68.569,
    transform: "translate(68.653 13.829) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_940",
    "data-name": "Grupo 940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_846",
    "data-name": "Trazado 846",
    d: "M1038.024,488.78a25.547,25.547,0,0,1,5.524-15.839l9.727,7.734a12.9,12.9,0,0,0-2.825,8.1,13.04,13.04,0,0,0,23.854,7.286l10.3,6.957a25.467,25.467,0,0,1-46.579-14.242Z",
    transform: "translate(-1038.024 -472.941)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_942",
    "data-name": "Grupo 942",
    transform: "translate(431.734 173.348)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_222",
    "data-name": "L\\xEDnea 222",
    x2: 90.401,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_223",
    "data-name": "L\\xEDnea 223",
    x2: 90.401,
    transform: "translate(0 11.764)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_224",
    "data-name": "L\\xEDnea 224",
    x2: 51.03,
    transform: "translate(0 23.528)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1703",
    "data-name": "Grupo 1703",
    transform: "translate(0 167.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_804",
    "data-name": "Grupo 804",
    transform: "translate(15.117 7.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_774",
    "data-name": "Trazado 774",
    d: "M441.226,636.974c-3.414,3.637-8.976,10.716-4.606,15.656,3.121,3.531,8.82,1.971,11.914-.653,3.946-3.345,6.292-10.772,3.381-15.418-2.506-4-8.216-3.806-12.188-2.7-4.441,1.235-9.234,4.33-10.472,9.031a7.752,7.752,0,0,0,8.3,9.65c5.724-.448,11.9-5.1,13.984-10.435a8.4,8.4,0,0,0-6.83-11.678c-7.541-1.153-18.173,5.28-13.432,13.754a.515.515,0,0,0,.888-.52c-3.771-6.739,3.539-11.733,9.6-12.293,3.051-.282,6.352.558,8.208,3.149,2.046,2.858,1.3,6.39-.411,9.177-2.921,4.748-11.787,10.919-17.171,6.424a7.264,7.264,0,0,1-1.81-8c.939-2.47,3.206-4.309,5.419-5.592,3.615-2.093,8.793-3.348,12.733-1.439,5.057,2.45,3.571,9.67,1.284,13.532-2.233,3.769-7.5,6.557-11.654,4.122-5.978-3.5.763-12.031,3.587-15.039.454-.482-.272-1.211-.727-.727Z",
    transform: "translate(-428.988 -630.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_819",
    "data-name": "Grupo 819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_818",
    "data-name": "Grupo 818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_817",
    "data-name": "Grupo 817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_800",
    "data-name": "Trazado 800",
    d: "M418.159,623.14l-.551,19.039A64.4,64.4,0,0,1,413.318,621c36.11,2.527,72.8,1.481,109.211.43-36.736,2.908-74.046,4.032-111.223,3.352",
    transform: "translate(-411.306 -621.004)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_801",
    "data-name": "Trazado 801",
    d: "M541.9,622a150.576,150.576,0,0,1-.212,16.922",
    transform: "translate(-430.219 -621.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_802",
    "data-name": "Trazado 802",
    d: "M545.044,623.5q-.426,16.269.369,32.537",
    transform: "translate(-430.685 -621.366)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_948",
    "data-name": "Grupo 948",
    transform: "translate(48.544 10.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_947",
    "data-name": "Grupo 947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_850",
    "data-name": "Trazado 850",
    d: "M468.087,634.415q25.165-1.649,50.353-.967",
    transform: "translate(-468.087 -633.249)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_851",
    "data-name": "Trazado 851",
    d: "M468.779,643.548h32.847",
    transform: "translate(-468.187 -634.743)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_852",
    "data-name": "Trazado 852",
    d: "M470.087,653.426a5.223,5.223,0,0,1,3.992-3.191,5.381,5.381,0,0,1,4.857,1.76,17.353,17.353,0,0,0,1.3,1.636c1.819,1.688,4.777.867,7.216.228a31.581,31.581,0,0,1,16.51.172",
    transform: "translate(-468.377 -635.703)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_853",
    "data-name": "Trazado 853",
    d: "M419.112,664.569q52.873-1.785,105.793-1.047",
    transform: "translate(-412.439 -627.14)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1702",
    "data-name": "Grupo 1702",
    transform: "translate(221.163 25.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_952",
    "data-name": "Grupo 952",
    transform: "translate(0 155.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_950",
    "data-name": "Grupo 950",
    transform: "translate(7.093 7.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_949",
    "data-name": "Grupo 949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_854",
    "data-name": "Trazado 854",
    d: "M680.819,609.867a84.687,84.687,0,0,1,8.379,9.869",
    transform: "translate(-678.658 -609.867)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_855",
    "data-name": "Trazado 855",
    d: "M687.029,610.976q-4.5,6.335-8.738,12.844",
    transform: "translate(-678.291 -610.028)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_951",
    "data-name": "Grupo 951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_856",
    "data-name": "Trazado 856",
    d: "M682.233,607.248c-3.413,3.636-8.975,10.717-4.606,15.656,3.121,3.531,8.819,1.97,11.914-.653,3.947-3.345,6.292-10.772,3.382-15.418-2.506-4-8.217-3.807-12.189-2.7-4.441,1.235-9.234,4.329-10.471,9.031a7.752,7.752,0,0,0,8.3,9.649c5.724-.448,11.9-5.1,13.984-10.435a8.4,8.4,0,0,0-6.83-11.679c-7.541-1.153-18.173,5.28-13.432,13.753a.514.514,0,0,0,.887-.519c-3.77-6.739,3.539-11.733,9.6-12.294,3.051-.281,6.352.558,8.208,3.15,2.046,2.858,1.3,6.39-.411,9.178-2.921,4.747-11.787,10.918-17.171,6.424a7.264,7.264,0,0,1-1.81-8c.939-2.47,3.206-4.31,5.419-5.592,3.616-2.093,8.793-3.349,12.733-1.439,5.057,2.45,3.571,9.67,1.283,13.532-2.232,3.768-7.5,6.557-11.653,4.122-5.978-3.5.763-12.031,3.587-15.039.454-.483-.272-1.211-.728-.727Z",
    transform: "translate(-669.995 -600.564)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1701",
    "data-name": "Grupo 1701",
    transform: "translate(115.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_955",
    "data-name": "Grupo 955",
    transform: "translate(8.138 10.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_861",
    "data-name": "Trazado 861",
    d: "M826.755,438.236c-3.413,3.636-8.975,10.716-4.606,15.656,3.122,3.53,8.82,1.97,11.914-.653,3.947-3.346,6.292-10.773,3.382-15.419-2.506-4-8.217-3.806-12.189-2.7-4.441,1.235-9.233,4.33-10.471,9.031a7.753,7.753,0,0,0,8.3,9.651c5.724-.449,11.9-5.1,13.984-10.436a8.4,8.4,0,0,0-6.83-11.678c-7.541-1.153-18.173,5.28-13.432,13.754.323.579,1.211.06.887-.519-3.77-6.74,3.539-11.734,9.6-12.294,3.051-.281,6.352.558,8.208,3.15,2.046,2.857,1.3,6.39-.411,9.177-2.921,4.748-11.787,10.918-17.171,6.424a7.263,7.263,0,0,1-1.81-8c.939-2.469,3.206-4.309,5.42-5.592,3.615-2.093,8.793-3.348,12.733-1.438,5.057,2.449,3.571,9.67,1.283,13.531-2.232,3.769-7.5,6.557-11.653,4.122-5.978-3.5.763-12.031,3.587-15.039.453-.482-.273-1.212-.728-.727Z",
    transform: "translate(-814.518 -431.551)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_225",
    "data-name": "L\\xEDnea 225",
    y1: 10.731,
    x2: 6.042,
    transform: "translate(32.154)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_226",
    "data-name": "L\\xEDnea 226",
    y1: 3.425,
    x2: 6.667,
    transform: "translate(37.363 9.418)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_227",
    "data-name": "L\\xEDnea 227",
    x1: 6.841,
    y2: 3.064,
    transform: "translate(0 32.061)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_228",
    "data-name": "L\\xEDnea 228",
    x1: 4.18,
    y2: 7.872,
    transform: "translate(5.13 35.302)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_982",
    "data-name": "Grupo 982",
    transform: "translate(10.076 19.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_872",
    "data-name": "Trazado 872",
    d: "M678.446,564.977C672.85,455.448,778.513,449.26,778.513,449.26",
    transform: "translate(-678.231 -445.449)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_981",
    "data-name": "Grupo 981",
    transform: "translate(92.97 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_873",
    "data-name": "Trazado 873",
    d: "M796.381,445.374l6.276,3.3v-.822a46.167,46.167,0,0,0-8,6.435.476.476,0,0,0,.673.673,45.052,45.052,0,0,1,7.805-6.286.48.48,0,0,0,0-.822l-6.276-3.3c-.542-.285-1.023.536-.48.822Z",
    transform: "translate(-794.52 -444.493)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1711",
    "data-name": "Grupo 1711",
    transform: "translate(118.902 245.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_811",
    "data-name": "Grupo 811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_809",
    "data-name": "Grupo 809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_782",
    "data-name": "Trazado 782",
    d: "M561.6,679.428l-.345,21.592A126.028,126.028,0,0,1,558.568,677c22.643,2.867,45.652,1.68,68.481.488a399.564,399.564,0,0,1-69.743,3.8",
    transform: "translate(-551.387 -675.89)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_783",
    "data-name": "Trazado 783",
    d: "M624.181,677.491l-.2,23.21a248.012,248.012,0,0,1-1.807-25l11.818,24.747c-2.794.957-5.887.805-8.873.64l-74.736-4.13,75.178-1.185L573.78,699",
    transform: "translate(-550.383 -675.701)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_784",
    "data-name": "Trazado 784",
    d: "M561.838,709.421h72.351",
    transform: "translate(-552.045 -680.592)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_785",
    "data-name": "Trazado 785",
    d: "M570.192,705.44l58.39,1.052",
    transform: "translate(-553.256 -680.015)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_786",
    "data-name": "Trazado 786",
    d: "M639.2,678.137q.232,9.6-.133,19.192",
    transform: "translate(-563.247 -676.054)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_787",
    "data-name": "Trazado 787",
    d: "M641.167,679.837q-.267,10.612.232,21.225",
    transform: "translate(-563.539 -676.301)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_810",
    "data-name": "Grupo 810",
    transform: "translate(36.002 8.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_788",
    "data-name": "Trazado 788",
    d: "M596.872,689.645a6.14,6.14,0,0,0-.377,1.779q-.055.917-.1,1.834c-.014.18-.132.269-.356.269a.527.527,0,0,1-.184-.032.719.719,0,0,1-.463-.723,3.593,3.593,0,0,1,.044-.458,3.725,3.725,0,0,0,.043-.447q.044-.313.108-.939a4.891,4.891,0,0,1-1.683,1.047.829.829,0,0,1-.259.042,1.168,1.168,0,0,1-.917-.561,1.245,1.245,0,0,1-.237-.776,3.081,3.081,0,0,1,.184-.96A11.869,11.869,0,0,1,594.5,686.3q.626-.83,1.11-.83c.287,0,.45.108.486.323a.339.339,0,0,1-.184.389c-.251.137-.384.212-.4.227A10.732,10.732,0,0,0,593.852,689a4.2,4.2,0,0,0-.464,1.758c0,.093,0,.187.01.28a.276.276,0,0,1,.065.1c.029.062.068.081.119.06a9.439,9.439,0,0,0,2.146-1.478,1.239,1.239,0,0,0,.248-.5.394.394,0,0,1,.389-.3c-.058,0,0-.008.172-.022.086-.014.143,0,.173.044a.964.964,0,0,1,.205.5A.548.548,0,0,1,596.872,689.645Z",
    transform: "translate(-592.494 -685.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_789",
    "data-name": "Trazado 789",
    d: "M602.1,690.3a2.675,2.675,0,0,1-1.8,1.7,1.254,1.254,0,0,1-.28.032,1.756,1.756,0,0,1-1.241-.669,1.66,1.66,0,0,1-.421-1.176,3.758,3.758,0,0,1,.474-1.715,2.616,2.616,0,0,1,.5-.669.937.937,0,0,1,.636-.334.483.483,0,0,1,.323.13,3.025,3.025,0,0,0,.809.344,1.217,1.217,0,0,1,.734.582,2.794,2.794,0,0,1,.378,1.24A1.25,1.25,0,0,1,602.1,690.3Zm-.863-.668c-.05-.525-.19-.838-.421-.939a.278.278,0,0,0-.1-.021c-.086,0-.194.073-.324.215a1.029,1.029,0,0,1-.334.291c-.05.021-.122,0-.216-.065a.5.5,0,0,0-.183-.1.076.076,0,0,0-.054.021,1.249,1.249,0,0,0-.378,1,1.388,1.388,0,0,0,.216.787q.3.442.507.442a1.2,1.2,0,0,0,.917-.592A1.494,1.494,0,0,0,601.238,689.634Z",
    transform: "translate(-593.345 -685.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_790",
    "data-name": "Trazado 790",
    d: "M604.661,692.576a.534.534,0,0,1-.043.3c-.044.1-.1.147-.157.15a.2.2,0,0,0-.134.049.091.091,0,0,1-.086.033q-.572-.216-.647-.561c-.021-.1.047-.2.205-.308a.656.656,0,0,1,.334-.145.7.7,0,0,1,.339.151A.468.468,0,0,1,604.661,692.576ZM605.708,686a21.131,21.131,0,0,1-.551,2.718,10.824,10.824,0,0,0-.388,2.793.224.224,0,0,1-.113.178.267.267,0,0,1-.211.06q-.549-.108-.582-.54c-.007-.151-.01-.3-.01-.453a11.862,11.862,0,0,1,.323-2.48q.5-2.167.539-2.46a.234.234,0,0,1,.161-.183.389.389,0,0,1,.27-.01l.366.108A.266.266,0,0,1,605.708,686Z",
    transform: "translate(-594.104 -685.49)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1725",
    "data-name": "Grupo 1725",
    transform: "translate(-5199.313 2221.362) rotate(-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_866-2",
    "data-name": "Trazado 866",
    d: "M9.227,0C-32.462,112.908,80.632,112.818,80.632,112.818",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_974-2",
    "data-name": "Grupo 974",
    transform: "translate(71.23 106.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_867-2",
    "data-name": "Trazado 867",
    d: "M3.229,10.269,9.6,5.931v.893A50.165,50.165,0,0,1,.177.854C-.342.438.394-.29.909.122a48.959,48.959,0,0,0,9.209,5.809.522.522,0,0,1,0,.893L3.751,11.161c-.551.376-1.069-.519-.522-.893Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_297",
    "data-name": "L\\xEDnea 297",
    y2: 92.128,
    transform: "translate(-4646.739 2375.113)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: "5 10"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_275",
    "data-name": "Elipse 275",
    cx: 51.296,
    cy: 51.296,
    r: 51.296,
    transform: "translate(-4499.25 1929.965)",
    fill: "#ffc0d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1726",
    "data-name": "Grupo 1726",
    transform: "translate(-4439.752 1882.596)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_148",
    "data-name": "Elipse 148",
    cx: 0.852,
    cy: 0.882,
    rx: 0.852,
    ry: 0.882,
    transform: "translate(84.392 1.549)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_149",
    "data-name": "Elipse 149",
    cx: 0.852,
    cy: 0.882,
    rx: 0.852,
    ry: 0.882,
    transform: "translate(4.46 1.549)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_200",
    "data-name": "L\\xEDnea 200",
    x2: 79.704,
    transform: "translate(5.394 2.431)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_921",
    "data-name": "Grupo 921"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_150",
    "data-name": "Elipse 150",
    cx: 42.158,
    cy: 42.554,
    rx: 42.158,
    ry: 42.554,
    transform: "translate(2.844 2.85)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_917",
    "data-name": "Grupo 917",
    transform: "translate(42.159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_778",
    "data-name": "Rect\\xE1ngulo 778",
    width: 5.333,
    height: 5.519,
    transform: "translate(0.356 0.368)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_779",
    "data-name": "Rect\\xE1ngulo 779",
    width: 4.977,
    height: 5.151,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_918",
    "data-name": "Grupo 918",
    transform: "translate(42.159 84.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_780",
    "data-name": "Rect\\xE1ngulo 780",
    width: 5.333,
    height: 5.519,
    transform: "translate(0.356 0.368)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_781",
    "data-name": "Rect\\xE1ngulo 781",
    width: 4.977,
    height: 5.151,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_919",
    "data-name": "Grupo 919",
    transform: "translate(84.803 42.456)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_782",
    "data-name": "Rect\\xE1ngulo 782",
    width: 5.333,
    height: 5.519,
    transform: "translate(0.356 0.368)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_783",
    "data-name": "Rect\\xE1ngulo 783",
    width: 4.977,
    height: 5.151,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_920",
    "data-name": "Grupo 920",
    transform: "translate(0 42.456)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_784",
    "data-name": "Rect\\xE1ngulo 784",
    width: 5.333,
    height: 5.519,
    transform: "translate(0.356 0.368)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_785",
    "data-name": "Rect\\xE1ngulo 785",
    width: 4.977,
    height: 5.151,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1727",
    "data-name": "Grupo 1727",
    transform: "translate(-4422.481 1985.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_956-2",
    "data-name": "Grupo 956"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_229-2",
    "data-name": "L\\xEDnea 229",
    y2: 60.958,
    transform: "translate(31.721)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_230-2",
    "data-name": "L\\xEDnea 230",
    x2: 63.441,
    transform: "translate(0 30.479)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_957-2",
    "data-name": "Grupo 957",
    transform: "translate(9.291 8.049)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_231-2",
    "data-name": "L\\xEDnea 231",
    x1: 43.104,
    y2: 43.104,
    transform: "translate(0.878 0.878)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_232-2",
    "data-name": "L\\xEDnea 232",
    x2: 44.86,
    y2: 44.86,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1728",
    "data-name": "Grupo 1728",
    transform: "translate(-4739.755 1866.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_861-2",
    "data-name": "Grupo 861",
    transform: "translate(0 20.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_860-2",
    "data-name": "Grupo 860",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_859-2",
    "data-name": "Grupo 859",
    transform: "translate(-245.919 58.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_804-2",
    "data-name": "Trazado 804",
    d: "M1088.587,409.559V587.227H913.114v89.694H860.39v-267.3",
    transform: "translate(-580.559 -391.992)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_831-2",
    "data-name": "Grupo 831",
    transform: "translate(0 66.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_827-2",
    "data-name": "Grupo 827",
    transform: "translate(0 60.007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_725-2",
    "data-name": "Rect\\xE1ngulo 725",
    width: 281.718,
    height: 17.567,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_823-2",
    "data-name": "Grupo 823",
    transform: "translate(5.097 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_104-2",
    "data-name": "Elipse 104",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_105-2",
    "data-name": "Elipse 105",
    cx: 0.644,
    cy: 0.644,
    r: 0.644,
    transform: "translate(2.631 2.631)",
    fill: "#fffaf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_824-2",
    "data-name": "Grupo 824",
    transform: "translate(15.491 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_106-2",
    "data-name": "Elipse 106",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_162-2",
    "data-name": "L\\xEDnea 162",
    x2: 3.458,
    transform: "translate(1.546 3.275)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_826-2",
    "data-name": "Grupo 826",
    transform: "translate(25.885 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_107-2",
    "data-name": "Elipse 107",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_825-2",
    "data-name": "Grupo 825",
    transform: "translate(1.351 1.351)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_163-2",
    "data-name": "L\\xEDnea 163",
    y2: 3.848,
    transform: "translate(1.924)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_164-2",
    "data-name": "L\\xEDnea 164",
    x1: 3.848,
    transform: "translate(0 1.924)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_165-2",
    "data-name": "L\\xEDnea 165",
    y2: 131.607,
    transform: "translate(0 77.574)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_166-2",
    "data-name": "L\\xEDnea 166",
    y2: 51.825,
    transform: "translate(281.719 77.574)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_807",
    "data-name": "Trazado 807",
    d: "M862.6,587.607h50.837V702.749",
    transform: "translate(-580.88 -484.121)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_108-2",
    "data-name": "Elipse 108",
    cx: 23.846,
    cy: 23.846,
    r: 23.846,
    transform: "translate(18.933 102.374)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_726-2",
    "data-name": "Rect\\xE1ngulo 726",
    width: 87.117,
    height: 43.876,
    transform: "translate(43.097 126.537)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_828-2",
    "data-name": "Grupo 828",
    transform: "translate(142.931 132.896)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_167-2",
    "data-name": "L\\xEDnea 167",
    x2: 76.039,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_168-2",
    "data-name": "L\\xEDnea 168",
    x2: 76.039,
    transform: "translate(0 11.764)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_169-2",
    "data-name": "L\\xEDnea 169",
    x2: 42.922,
    transform: "translate(0 23.528)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_829-2",
    "data-name": "Grupo 829",
    transform: "translate(313.968 113.531)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_170-2",
    "data-name": "L\\xEDnea 170",
    x2: 9.413,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_171-2",
    "data-name": "L\\xEDnea 171",
    x2: 9.413,
    transform: "translate(0 4.899)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_172-2",
    "data-name": "L\\xEDnea 172",
    x2: 5.314,
    transform: "translate(0 9.798)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_830-2",
    "data-name": "Grupo 830",
    transform: "translate(11.938 199.664)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_109-2",
    "data-name": "Elipse 109",
    cx: 3.206,
    cy: 3.206,
    r: 3.206,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_110-2",
    "data-name": "Elipse 110",
    cx: 3.206,
    cy: 3.206,
    r: 3.206,
    transform: "translate(9.988)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_111-2",
    "data-name": "Elipse 111",
    cx: 3.206,
    cy: 3.206,
    r: 3.206,
    transform: "translate(19.977 0.247)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_112-2",
    "data-name": "Elipse 112",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(279.555 87.655)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_113-2",
    "data-name": "Elipse 113",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(86.916)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_114",
    "data-name": "Elipse 114",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(330.517 166.138)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_173-2",
    "data-name": "L\\xEDnea 173",
    y1: 56.96,
    transform: "translate(89.757 3.047)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_727-2",
    "data-name": "Rect\\xE1ngulo 727",
    width: 114.156,
    height: 83.578,
    transform: "translate(173.552 189.58)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_808",
    "data-name": "Trazado 808",
    d: "M865.266,571.7h69.019a3.6,3.6,0,0,1,3.6,3.6v71.22a3.6,3.6,0,0,1-3.6,3.6H916.228",
    transform: "translate(-581.267 -481.813)",
    fill: "none",
    stroke: "#0067ec",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_728-2",
    "data-name": "Rect\\xE1ngulo 728",
    width: 43.828,
    height: 36.693,
    transform: "translate(114.945 192.128)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_836",
    "data-name": "Grupo 836",
    transform: "translate(226.309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_729",
    "data-name": "Rect\\xE1ngulo 729",
    width: 281.718,
    height: 17.567,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_832",
    "data-name": "Grupo 832",
    transform: "translate(5.097 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_115",
    "data-name": "Elipse 115",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_116",
    "data-name": "Elipse 116",
    cx: 0.644,
    cy: 0.644,
    r: 0.644,
    transform: "translate(2.631 2.631)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_833",
    "data-name": "Grupo 833",
    transform: "translate(15.491 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_117",
    "data-name": "Elipse 117",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_174",
    "data-name": "L\\xEDnea 174",
    x2: 3.458,
    transform: "translate(1.546 3.275)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_835",
    "data-name": "Grupo 835",
    transform: "translate(25.885 5.061)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_118",
    "data-name": "Elipse 118",
    cx: 3.275,
    cy: 3.275,
    r: 3.275,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_834",
    "data-name": "Grupo 834",
    transform: "translate(1.351 1.351)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_175",
    "data-name": "L\\xEDnea 175",
    y2: 3.848,
    transform: "translate(1.924)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_176",
    "data-name": "L\\xEDnea 176",
    x1: 3.848,
    transform: "translate(0 1.924)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_837",
    "data-name": "Grupo 837",
    transform: "translate(332.555 72.889)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_177",
    "data-name": "L\\xEDnea 177",
    x2: 112.724,
    fill: "none",
    stroke: "#ff3900",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_178",
    "data-name": "L\\xEDnea 178",
    x2: 112.724,
    transform: "translate(0 11.764)",
    fill: "none",
    stroke: "#ff3900",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_179",
    "data-name": "L\\xEDnea 179",
    x2: 63.631,
    transform: "translate(0 23.528)",
    fill: "none",
    stroke: "#ff3900",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_730",
    "data-name": "Rect\\xE1ngulo 730",
    width: 133.522,
    height: 172.253,
    transform: "translate(418.681 57.636)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_839-2",
    "data-name": "Grupo 839",
    transform: "translate(238.25 30.775)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_119-2",
    "data-name": "Elipse 119",
    cx: 15.882,
    cy: 15.882,
    r: 15.882,
    transform: "translate(53.878)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_731-2",
    "data-name": "Rect\\xE1ngulo 731",
    width: 55.505,
    height: 68.569,
    transform: "translate(13.829 15.37)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_838-2",
    "data-name": "Grupo 838",
    transform: "translate(0 37.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_809-2",
    "data-name": "Trazado 809",
    d: "M827.593,515.385a25.542,25.542,0,0,1-15.839-5.525l7.733-9.727a12.9,12.9,0,0,0,8.106,2.824,13.04,13.04,0,0,0,7.286-23.855l6.957-10.3a25.468,25.468,0,0,1-14.242,46.579Z",
    transform: "translate(-811.754 -468.806)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_846",
    "data-name": "Grupo 846",
    transform: "translate(431.697 71.755)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_120",
    "data-name": "Elipse 120",
    cx: 15.882,
    cy: 15.882,
    r: 15.882,
    transform: "translate(52.26 53.878)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_732",
    "data-name": "Rect\\xE1ngulo 732",
    width: 55.505,
    height: 68.569,
    transform: "translate(68.653 13.829) rotate(90)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_840",
    "data-name": "Grupo 840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_810",
    "data-name": "Trazado 810",
    d: "M1038.024,488.78a25.547,25.547,0,0,1,5.524-15.839l9.727,7.734a12.9,12.9,0,0,0-2.825,8.1,13.04,13.04,0,0,0,23.854,7.286l10.3,6.957a25.467,25.467,0,0,1-46.579-14.242Z",
    transform: "translate(-1038.024 -472.941)",
    fill: "#ffc0d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_842",
    "data-name": "Grupo 842",
    transform: "translate(52.26 53.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_841",
    "data-name": "Grupo 841",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_733",
    "data-name": "Rect\\xE1ngulo 733",
    width: 55.505,
    height: 68.569,
    transform: "translate(16.393 -40.049) rotate(90)",
    fill: "#fffaf0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_845",
    "data-name": "Grupo 845",
    transform: "translate(0.083 13.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_844",
    "data-name": "Grupo 844",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_843",
    "data-name": "Grupo 843",
    transform: "translate(-0.083 -13.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_811",
    "data-name": "Trazado 811",
    d: "M1038.024,488.78a25.547,25.547,0,0,1,5.524-15.839l9.727,7.734a12.9,12.9,0,0,0-2.825,8.1,13.04,13.04,0,0,0,23.854,7.286l10.3,6.957a25.467,25.467,0,0,1-46.579-14.242Z",
    transform: "translate(-1038.024 -472.941)",
    fill: "#ff3900"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_812",
    "data-name": "Trazado 812",
    d: "M953.653,691.289h91.475V815.637H954.111V757.424",
    transform: "translate(-594.088 -432.86)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_847",
    "data-name": "Grupo 847",
    transform: "translate(431.734 173.348)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_180",
    "data-name": "L\\xEDnea 180",
    x2: 90.401,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_181",
    "data-name": "L\\xEDnea 181",
    x2: 90.401,
    transform: "translate(0 11.764)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_182",
    "data-name": "L\\xEDnea 182",
    x2: 51.03,
    transform: "translate(0 23.528)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_856",
    "data-name": "Grupo 856",
    transform: "translate(539.202 197.421)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_183",
    "data-name": "L\\xEDnea 183",
    y1: 20.719,
    x2: 33.124,
    transform: "translate(2.54 1.848)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_184",
    "data-name": "L\\xEDnea 184",
    y1: 22.33,
    x2: 33.495,
    transform: "translate(67.936 66.43)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_735",
    "data-name": "Rect\\xE1ngulo 735",
    width: 66.193,
    height: 66.193,
    transform: "translate(35.665 1.848)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_736",
    "data-name": "Rect\\xE1ngulo 736",
    width: 66.193,
    height: 66.193,
    transform: "translate(2.568 22.982)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_848",
    "data-name": "Grupo 848",
    transform: "translate(0 19.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_737",
    "data-name": "Rect\\xE1ngulo 737",
    width: 5.444,
    height: 5.633,
    transform: "translate(0.363 0.376)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_738",
    "data-name": "Rect\\xE1ngulo 738",
    width: 5.081,
    height: 5.258,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_849",
    "data-name": "Grupo 849",
    transform: "translate(32.698)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_739",
    "data-name": "Rect\\xE1ngulo 739",
    width: 5.444,
    height: 5.633,
    transform: "translate(0.363 0.376)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_740",
    "data-name": "Rect\\xE1ngulo 740",
    width: 5.081,
    height: 5.258,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_850",
    "data-name": "Grupo 850",
    transform: "translate(65.396 86.131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_741",
    "data-name": "Rect\\xE1ngulo 741",
    width: 5.444,
    height: 5.633,
    transform: "translate(0.363 0.376)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_742",
    "data-name": "Rect\\xE1ngulo 742",
    width: 5.081,
    height: 5.258,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_851",
    "data-name": "Grupo 851",
    transform: "translate(98.891 63.801)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_743",
    "data-name": "Rect\\xE1ngulo 743",
    width: 5.444,
    height: 5.633,
    transform: "translate(0.363 0.376)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_744",
    "data-name": "Rect\\xE1ngulo 744",
    width: 5.081,
    height: 5.258,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_185",
    "data-name": "L\\xEDnea 185",
    x1: 33.495,
    y2: 19.938,
    transform: "translate(67.936 2.629)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_852",
    "data-name": "Grupo 852",
    transform: "translate(65.396 19.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_745",
    "data-name": "Rect\\xE1ngulo 745",
    width: 5.444,
    height: 5.633,
    transform: "translate(0.363 0.376)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_746",
    "data-name": "Rect\\xE1ngulo 746",
    width: 5.081,
    height: 5.258,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_853",
    "data-name": "Grupo 853",
    transform: "translate(98.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_747",
    "data-name": "Rect\\xE1ngulo 747",
    width: 5.444,
    height: 5.633,
    transform: "translate(0.363 0.376)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_748",
    "data-name": "Rect\\xE1ngulo 748",
    width: 5.081,
    height: 5.258,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_186",
    "data-name": "L\\xEDnea 186",
    x1: 32.64,
    y2: 22.33,
    transform: "translate(2.54 66.43)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_854",
    "data-name": "Grupo 854",
    transform: "translate(32.64 63.801)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_749",
    "data-name": "Rect\\xE1ngulo 749",
    width: 5.444,
    height: 5.633,
    transform: "translate(0.363 0.376)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_750",
    "data-name": "Rect\\xE1ngulo 750",
    width: 5.081,
    height: 5.258,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_855",
    "data-name": "Grupo 855",
    transform: "translate(0 86.131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_751",
    "data-name": "Rect\\xE1ngulo 751",
    width: 5.444,
    height: 5.633,
    transform: "translate(0.363 0.376)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_752",
    "data-name": "Rect\\xE1ngulo 752",
    width: 5.081,
    height: 5.258,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_858",
    "data-name": "Grupo 858",
    transform: "translate(333.786 111.132)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_753",
    "data-name": "Rect\\xE1ngulo 753",
    width: 67.54,
    height: 20.519,
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_857",
    "data-name": "Grupo 857",
    transform: "translate(27.529 7.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M960.466,530.376a3.1,3.1,0,0,1-.162,1.022,2.394,2.394,0,0,1-.47.814,2.147,2.147,0,0,1-.745.538,2.416,2.416,0,0,1-.984.194,2.316,2.316,0,0,1-.981-.2,2.409,2.409,0,0,1-.759-.545,2.44,2.44,0,0,1-.49-.786,2.551,2.551,0,0,1-.174-.936,2.48,2.48,0,0,1,.184-.953,2.517,2.517,0,0,1,.5-.787,2.374,2.374,0,0,1,.762-.534,2.329,2.329,0,0,1,.96-.2,2.806,2.806,0,0,1,.78.1,2.353,2.353,0,0,1,.627.283,1.991,1.991,0,0,1,.473.429,2.165,2.165,0,0,1,.314.534h-.627a1.387,1.387,0,0,0-.582-.61,1.934,1.934,0,0,0-.984-.235,1.787,1.787,0,0,0-.766.157,1.714,1.714,0,0,0-.572.422,1.883,1.883,0,0,0-.361.616,2.2,2.2,0,0,0-.126.745,2.267,2.267,0,0,0,.143.824,1.867,1.867,0,0,0,.395.629,1.7,1.7,0,0,0,.593.4,1.914,1.914,0,0,0,.735.14,1.725,1.725,0,0,0,.656-.123,1.653,1.653,0,0,0,.528-.337,1.677,1.677,0,0,0,.361-.507,1.983,1.983,0,0,0,.17-.64h-1.989v-.517h2.587Z",
    transform: "translate(-955.7 -528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_814",
    "data-name": "Trazado 814",
    d: "M962,530.706a1.646,1.646,0,0,1,.923-.912,1.907,1.907,0,0,1,1.388,0,1.662,1.662,0,0,1,.552.364,1.639,1.639,0,0,1,.361.551,1.832,1.832,0,0,1,.129.687,1.789,1.789,0,0,1-.129.678,1.725,1.725,0,0,1-.365.555,1.751,1.751,0,0,1-.555.378,1.713,1.713,0,0,1-.694.139,1.748,1.748,0,0,1-1.242-.507,1.711,1.711,0,0,1-.369-.555,1.871,1.871,0,0,1,0-1.382Zm.522,1.2a1.264,1.264,0,0,0,.259.4,1.139,1.139,0,0,0,.83.355,1.183,1.183,0,0,0,.477-.1,1.112,1.112,0,0,0,.374-.266,1.238,1.238,0,0,0,.245-.4,1.389,1.389,0,0,0,.089-.5,1.371,1.371,0,0,0-.085-.486,1.228,1.228,0,0,0-.239-.4,1.093,1.093,0,0,0-.374-.269,1.248,1.248,0,0,0-.963,0,1.135,1.135,0,0,0-.375.263,1.193,1.193,0,0,0-.245.395,1.373,1.373,0,0,0-.089.5A1.3,1.3,0,0,0,962.521,531.908Z",
    transform: "translate(-956.595 -528.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_815",
    "data-name": "Trazado 815",
    d: "M967.344,531.531h-.49l-.055-3.357h.6Zm.055.688v.6h-.6v-.6Z",
    transform: "translate(-957.31 -528.025)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1705",
    "data-name": "Grupo 1705",
    transform: "translate(134.888 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_132",
    "data-name": "Elipse 132",
    cx: 2.564,
    cy: 2.564,
    r: 2.564,
    transform: "translate(0)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_133",
    "data-name": "Elipse 133",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(83.232 77.53)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_820",
    "data-name": "Trazado 820",
    d: "M1064.768,376.824v-53.9a3.058,3.058,0,0,0-3.058-3.057H984.664a3.058,3.058,0,0,1-3.057-3.058V299",
    transform: "translate(-978.949 -296.436)",
    fill: "none",
    stroke: "#0067ec",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1709",
    "data-name": "Grupo 1709",
    transform: "translate(87.193 272.411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_143",
    "data-name": "Elipse 143",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(21.405)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1708",
    "data-name": "Grupo 1708"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_122",
    "data-name": "Elipse 122",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(83.58)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_198",
    "data-name": "L\\xEDnea 198",
    x2: 86.126,
    transform: "translate(0 2.415)",
    fill: "none",
    stroke: "#0067ec",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1706",
    "data-name": "Grupo 1706",
    transform: "translate(303.585 218.345)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_144",
    "data-name": "Elipse 144",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(71.815 0)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_145",
    "data-name": "Elipse 145",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(0 0)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_199",
    "data-name": "L\\xEDnea 199",
    x2: 72.191,
    transform: "translate(2.77 2.415)",
    fill: "none",
    stroke: "#0067ec",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1707",
    "data-name": "Grupo 1707",
    transform: "translate(39.752 378.208)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_146",
    "data-name": "Elipse 146",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_147",
    "data-name": "Elipse 147",
    cx: 2.548,
    cy: 2.548,
    r: 2.548,
    transform: "translate(71.347 46.885)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_840",
    "data-name": "Trazado 840",
    d: "M872.756,741.429h16.992a3.058,3.058,0,0,1,3.058,3.058v40.422a3.057,3.057,0,0,0,3.057,3.057h46.512",
    transform: "translate(-868.023 -738.823)",
    fill: "none",
    stroke: "#0067ec",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_862",
    "data-name": "Trazado 862",
    d: "M875.768,713.534c12.224-24.991,24.687-52.815,34.5-79.946,7.04-19.463-25.1-45.906-18.809-64.975,11.628-35.256,53.512-27.12,52.151-60.7-2.565-63.265,46.365-55.57,44.457-96.608a141.826,141.826,0,0,0-5.215-31.386",
    transform: "translate(-828.709 -308.174)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1729",
    "data-name": "Grupo 1729",
    transform: "translate(-4585.559 2236.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_841",
    "data-name": "Trazado 841",
    d: "M1029.335,734.329l13.451-17.292-.811,21.892,21.419-4.6L1048.7,750.578l19.364,10.243-21.7,3,25.387,35.388L1036.06,772.47l-6.725,20.849-6.725-20.849-18.553,11.648,8.25-20.294-21.7-3,19.365-10.243-14.693-16.249,21.419,4.6-.811-21.892Z",
    transform: "translate(-988.059 -714.394)",
    fill: "#ffc0d4",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_907",
    "data-name": "Grupo 907",
    transform: "translate(51.451 1.727)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_760",
    "data-name": "Rect\\xE1ngulo 760",
    width: 4.835,
    height: 4.835,
    transform: "translate(0.322 0.322)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_761",
    "data-name": "Rect\\xE1ngulo 761",
    width: 4.512,
    height: 4.512,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_908",
    "data-name": "Grupo 908",
    transform: "translate(25.208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_762",
    "data-name": "Rect\\xE1ngulo 762",
    width: 4.835,
    height: 4.835,
    transform: "translate(0.322 0.322)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_763",
    "data-name": "Rect\\xE1ngulo 763",
    width: 4.512,
    height: 4.512,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_909",
    "data-name": "Grupo 909",
    transform: "translate(4.834 18.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_764",
    "data-name": "Rect\\xE1ngulo 764",
    width: 4.835,
    height: 4.835,
    transform: "translate(0.322 0.322)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_765",
    "data-name": "Rect\\xE1ngulo 765",
    width: 4.512,
    height: 4.512,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_910",
    "data-name": "Grupo 910",
    transform: "translate(0 42.819)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_766",
    "data-name": "Rect\\xE1ngulo 766",
    width: 4.835,
    height: 4.835,
    transform: "translate(0.322 0.322)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_767",
    "data-name": "Rect\\xE1ngulo 767",
    width: 4.512,
    height: 4.512,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_911",
    "data-name": "Grupo 911",
    transform: "translate(13.122 66.645)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_768",
    "data-name": "Rect\\xE1ngulo 768",
    width: 4.835,
    height: 4.835,
    transform: "translate(0.322 0.322)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_769",
    "data-name": "Rect\\xE1ngulo 769",
    width: 4.512,
    height: 4.512,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_912",
    "data-name": "Grupo 912",
    transform: "translate(39.02 76.659)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_770",
    "data-name": "Rect\\xE1ngulo 770",
    width: 4.835,
    height: 4.835,
    transform: "translate(0.322 0.322)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_771",
    "data-name": "Rect\\xE1ngulo 771",
    width: 4.512,
    height: 4.512,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_913",
    "data-name": "Grupo 913",
    transform: "translate(81.152 82.093)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_772",
    "data-name": "Rect\\xE1ngulo 772",
    width: 4.835,
    height: 4.835,
    transform: "translate(0.322 0.322)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_773",
    "data-name": "Rect\\xE1ngulo 773",
    width: 4.512,
    height: 4.512,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_914",
    "data-name": "Grupo 914",
    transform: "translate(76.659 43.855)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_774",
    "data-name": "Rect\\xE1ngulo 774",
    width: 4.835,
    height: 4.835,
    transform: "translate(0.322 0.322)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_775",
    "data-name": "Rect\\xE1ngulo 775",
    width: 4.512,
    height: 4.512,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_915",
    "data-name": "Grupo 915",
    transform: "translate(72.515 17.956)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_776",
    "data-name": "Rect\\xE1ngulo 776",
    width: 4.835,
    height: 4.835,
    transform: "translate(0.322 0.322)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_777",
    "data-name": "Rect\\xE1ngulo 777",
    width: 4.512,
    height: 4.512,
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_10",
    "data-name": "Enmascarar grupo 10",
    transform: "translate(-5203.199 2502.725)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1753",
    "data-name": "Grupo 1753",
    transform: "translate(6.793 58.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1733",
    "data-name": "Grupo 1733",
    transform: "translate(99.218 66.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1732",
    "data-name": "Grupo 1732"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_276",
    "data-name": "Elipse 276",
    cx: 62.939,
    cy: 62.939,
    r: 62.939,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1731",
    "data-name": "Grupo 1731",
    transform: "translate(43.325 39.562)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_298",
    "data-name": "L\\xEDnea 298",
    y2: 54.343,
    transform: "translate(19.614)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1730",
    "data-name": "Grupo 1730",
    transform: "translate(0 0.599)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_277",
    "data-name": "Elipse 277",
    cx: 2.997,
    cy: 2.997,
    r: 2.997
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_278",
    "data-name": "Elipse 278",
    cx: 2.997,
    cy: 2.997,
    r: 2.997,
    transform: "translate(33.233)"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_299",
    "data-name": "L\\xEDnea 299",
    x2: 12.288,
    y2: 9.486,
    transform: "translate(76.558 35.231)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_300",
    "data-name": "L\\xEDnea 300",
    x1: 12.288,
    y2: 9.486,
    transform: "translate(36.489 35.231)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1736",
    "data-name": "Grupo 1736",
    transform: "translate(194.443)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_279",
    "data-name": "Elipse 279",
    cx: 75.56,
    cy: 75.56,
    r: 75.56,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1735",
    "data-name": "Grupo 1735",
    transform: "translate(48.934 47.495)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_301",
    "data-name": "L\\xEDnea 301",
    y2: 40.288,
    transform: "translate(26.626)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1734",
    "data-name": "Grupo 1734",
    transform: "translate(0 0.72)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_280",
    "data-name": "Elipse 280",
    cx: 3.598,
    cy: 3.598,
    r: 3.598
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_281",
    "data-name": "Elipse 281",
    cx: 3.598,
    cy: 3.598,
    r: 3.598,
    transform: "translate(46.055)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1406",
    "data-name": "Trazado 1406",
    d: "M728.006,1136.889A9.215,9.215,0,0,1,717.339,1148",
    transform: "translate(-689.793 -1095.413)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1739",
    "data-name": "Grupo 1739",
    transform: "translate(0 53.51)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_282",
    "data-name": "Elipse 282",
    cx: 55.647,
    cy: 55.647,
    r: 55.647,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1738",
    "data-name": "Grupo 1738",
    transform: "translate(36.038 34.978)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_302",
    "data-name": "L\\xEDnea 302",
    y2: 29.671,
    transform: "translate(19.609)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1737",
    "data-name": "Grupo 1737",
    transform: "translate(0 0.53)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_283",
    "data-name": "Elipse 283",
    cx: 2.65,
    cy: 2.65,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_284",
    "data-name": "Elipse 284",
    cx: 2.65,
    cy: 2.65,
    r: 2.65,
    transform: "translate(33.918)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1407",
    "data-name": "Trazado 1407",
    d: "M806.84,1050.464a6.788,6.788,0,0,1-7.856,8.184",
    transform: "translate(-778.698 -1019.918)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1743",
    "data-name": "Grupo 1743",
    transform: "translate(310.595 40.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1742",
    "data-name": "Grupo 1742",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_285",
    "data-name": "Elipse 285",
    cx: 58.991,
    cy: 58.991,
    r: 58.991,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1741",
    "data-name": "Grupo 1741",
    transform: "translate(33.759 37.08)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_303",
    "data-name": "L\\xEDnea 303",
    y2: 50.934,
    transform: "translate(25.232)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1740",
    "data-name": "Grupo 1740",
    transform: "translate(7.009 9.111)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_286",
    "data-name": "Elipse 286",
    cx: 2.809,
    cy: 2.809,
    r: 2.809
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_287",
    "data-name": "Elipse 287",
    cx: 2.809,
    cy: 2.809,
    r: 2.809,
    transform: "translate(30.827)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_304",
    "data-name": "L\\xEDnea 304",
    y1: 5.277,
    x2: 14.431,
    transform: "translate(35.524 2.023)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_305",
    "data-name": "L\\xEDnea 305",
    x1: 14.431,
    y1: 4.422,
    transform: "translate(0 2.878)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1746",
    "data-name": "Grupo 1746",
    transform: "translate(523.903 6.992)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_288",
    "data-name": "Elipse 288",
    cx: 72.896,
    cy: 72.896,
    r: 72.896,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1745",
    "data-name": "Grupo 1745",
    transform: "translate(47.209 45.82)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_306",
    "data-name": "L\\xEDnea 306",
    y2: 35.827,
    transform: "translate(25.687)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1744",
    "data-name": "Grupo 1744",
    transform: "translate(0 0.694)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_289",
    "data-name": "Elipse 289",
    cx: 3.471,
    cy: 3.471,
    r: 3.471
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_290",
    "data-name": "Elipse 290",
    cx: 3.471,
    cy: 3.471,
    r: 3.471,
    transform: "translate(44.432)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1749",
    "data-name": "Grupo 1749",
    transform: "translate(645.304 43.754)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_291",
    "data-name": "Elipse 291",
    cx: 57.469,
    cy: 57.469,
    r: 57.469,
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1748",
    "data-name": "Grupo 1748",
    transform: "translate(37.218 36.123)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_307",
    "data-name": "L\\xEDnea 307",
    y2: 30.642,
    transform: "translate(20.251)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1747",
    "data-name": "Grupo 1747",
    transform: "translate(0 0.547)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_292",
    "data-name": "Elipse 292",
    cx: 2.737,
    cy: 2.737,
    r: 2.737
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_293",
    "data-name": "Elipse 293",
    cx: 2.737,
    cy: 2.737,
    r: 2.737,
    transform: "translate(35.028)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1408",
    "data-name": "Trazado 1408",
    d: "M1121.123,1163.15a7.01,7.01,0,0,1-8.113,8.452",
    transform: "translate(-1092.059 -1131.605)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1752",
    "data-name": "Grupo 1752",
    transform: "translate(393.952 26.655)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_294",
    "data-name": "Elipse 294",
    cx: 84.033,
    cy: 84.033,
    r: 84.033,
    transform: "translate(0)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1751",
    "data-name": "Grupo 1751",
    transform: "translate(54.421 52.821)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_308",
    "data-name": "L\\xEDnea 308",
    y2: 68.931,
    transform: "translate(29.612)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1750",
    "data-name": "Grupo 1750",
    transform: "translate(0 0.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_295",
    "data-name": "Elipse 295",
    cx: 4.002,
    cy: 4.002,
    r: 4.002
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_296",
    "data-name": "Elipse 296",
    cx: 4.002,
    cy: 4.002,
    r: 4.002,
    transform: "translate(51.22)"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_297",
    "data-name": "Elipse 297",
    cx: 9.404,
    cy: 9.404,
    r: 9.404,
    transform: "translate(587.192 99.753)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1754",
    "data-name": "Grupo 1754",
    transform: "translate(-5021.292 2470.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_821",
    "data-name": "Trazado 821",
    d: "M566,956.088a26.008,26.008,0,0,0,26.007,26.005h82.213a25.88,25.88,0,0,0,11.56-2.7l14.446,14.446V956.088a26.008,26.008,0,0,0-26.006-26.006H592.006A26.007,26.007,0,0,0,566,956.088Z",
    transform: "translate(-566 -930.082)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_871",
    "data-name": "Grupo 871",
    transform: "translate(46.167 21.303)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_134",
    "data-name": "Elipse 134",
    cx: 4.702,
    cy: 4.702,
    r: 4.702
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_135",
    "data-name": "Elipse 135",
    cx: 4.702,
    cy: 4.702,
    r: 4.702,
    transform: "translate(16.244)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_136",
    "data-name": "Elipse 136",
    cx: 4.702,
    cy: 4.702,
    r: 4.702,
    transform: "translate(32.488)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1755",
    "data-name": "Grupo 1755",
    transform: "translate(-4521.673 2519.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1402",
    "data-name": "Trazado 1402",
    d: "M24.105,8.624h1.971A4.068,4.068,0,0,0,25.6,7.218a4.113,4.113,0,0,0-.941-1.14,4.314,4.314,0,0,0-1.351-.764,5.394,5.394,0,0,0-3.477.022,4.143,4.143,0,0,0-1.373.83,3.814,3.814,0,0,0-.9,1.24,3.606,3.606,0,0,0-.321,1.506,3.728,3.728,0,0,0,1.019,2.724,7.285,7.285,0,0,0,3.1,1.683A6.045,6.045,0,0,1,23.8,14.6a2.741,2.741,0,0,1,.8,2.059,3.084,3.084,0,0,1-.177,1.019,2.8,2.8,0,0,1-.531.919,2.66,2.66,0,0,1-.9.664,2.913,2.913,0,0,1-1.251.255,2.959,2.959,0,0,1-2.037-.686,3.651,3.651,0,0,1-1.085-1.838H16.6a5.1,5.1,0,0,0,1.849,3.122,5.379,5.379,0,0,0,3.266,1,4.976,4.976,0,0,0,2.059-.4,4.463,4.463,0,0,0,1.484-1.052,4.419,4.419,0,0,0,.9-1.461,4.721,4.721,0,0,0,.3-1.65,5.59,5.59,0,0,0-.221-1.605,3.788,3.788,0,0,0-.742-1.362,5.123,5.123,0,0,0-1.384-1.118,9.886,9.886,0,0,0-2.148-.875,6.212,6.212,0,0,1-2.093-1.008A2.021,2.021,0,0,1,19.1,8.912a2.18,2.18,0,0,1,.664-1.639A2.534,2.534,0,0,1,21.6,6.631,2.446,2.446,0,0,1,23.3,7.2,2.551,2.551,0,0,1,24.105,8.624Zm4.407,6.687a5.777,5.777,0,0,0,.432,2.236,5.506,5.506,0,0,0,1.2,1.8A5.686,5.686,0,0,0,34.18,21a5.587,5.587,0,0,0,2.259-.454,5.711,5.711,0,0,0,1.8-1.229,5.514,5.514,0,0,0,1.185-1.8,5.768,5.768,0,0,0,.421-2.2,5.91,5.91,0,0,0-.421-2.236,5.328,5.328,0,0,0-1.174-1.794A5.468,5.468,0,0,0,36.461,10.1a6.2,6.2,0,0,0-4.517-.011,5.45,5.45,0,0,0-1.8,1.174,5.382,5.382,0,0,0-1.2,1.794A5.835,5.835,0,0,0,28.512,15.311Zm1.816,0a4.462,4.462,0,0,1,.288-1.628,3.932,3.932,0,0,1,.8-1.284,3.664,3.664,0,0,1,1.218-.853,4.047,4.047,0,0,1,3.133.011,3.574,3.574,0,0,1,1.218.875,4.01,4.01,0,0,1,.775,1.3,4.675,4.675,0,0,1-.011,3.2,4.035,4.035,0,0,1-.8,1.306,3.588,3.588,0,0,1-1.218.864,3.825,3.825,0,0,1-1.55.31,3.716,3.716,0,0,1-2.7-1.151,4.175,4.175,0,0,1-.841-1.3A4.239,4.239,0,0,1,30.327,15.311ZM52.249,9.665a5.076,5.076,0,0,0-2.17.454,5.177,5.177,0,0,0-1.661,1.207,5.374,5.374,0,0,0-1.063,1.76,5.931,5.931,0,0,0-.376,2.093,6.35,6.35,0,0,0,.41,2.3,5.688,5.688,0,0,0,1.14,1.849A5.123,5.123,0,0,0,50.3,20.559,5.823,5.823,0,0,0,52.6,21a5.175,5.175,0,0,0,3.023-.919,4.937,4.937,0,0,0,1-.908,5.862,5.862,0,0,0,.675-1.008H55.283a3.724,3.724,0,0,1-1.14.952,3.377,3.377,0,0,1-1.583.332,3.49,3.49,0,0,1-1.428-.3,4.132,4.132,0,0,1-1.2-.8,3.889,3.889,0,0,1-.83-1.151,3.188,3.188,0,0,1-.31-1.384h8.658a1.712,1.712,0,0,0,.033-.288q.011-.2.011-.354a6.736,6.736,0,0,0-.277-1.838,5.27,5.27,0,0,0-.9-1.783A5,5,0,0,0,54.7,10.207,5.1,5.1,0,0,0,52.249,9.665Zm0,1.528a3.236,3.236,0,0,1,1.329.266,3.527,3.527,0,0,1,1.041.7,3.36,3.36,0,0,1,.709,1.008,3.8,3.8,0,0,1,.332,1.2H48.817a3.973,3.973,0,0,1,.321-1.174,3.337,3.337,0,0,1,.7-1.019,3.341,3.341,0,0,1,2.414-.974Zm17.958,9.433V10.019H68.459v1.528h-.022a6.377,6.377,0,0,0-.62-.664,4.338,4.338,0,0,0-.819-.6,5.134,5.134,0,0,0-1.041-.443,4.44,4.44,0,0,0-1.306-.177,5.661,5.661,0,0,0-2.2.421,5.411,5.411,0,0,0-1.76,1.174,5.328,5.328,0,0,0-1.174,1.794,6.358,6.358,0,0,0,.022,4.606,5.614,5.614,0,0,0,1.2,1.794A5.182,5.182,0,0,0,62.469,20.6a5.469,5.469,0,0,0,2.07.4,4.708,4.708,0,0,0,2.325-.543,5.261,5.261,0,0,0,1.55-1.251h.044v1.417Zm-9.3-5.314a4.765,4.765,0,0,1,.244-1.495,4.137,4.137,0,0,1,.72-1.329,3.461,3.461,0,0,1,1.218-.941,3.993,3.993,0,0,1,1.738-.354A3.618,3.618,0,0,1,67.5,12.344a4.059,4.059,0,0,1,.819,1.318,4.677,4.677,0,0,1,.3,1.716,4.111,4.111,0,0,1-.321,1.65,4.2,4.2,0,0,1-.853,1.284,3.834,3.834,0,0,1-1.218.841,3.567,3.567,0,0,1-1.439.3,3.706,3.706,0,0,1-3.643-2.624A5.043,5.043,0,0,1,60.908,15.311Zm17.338-2.746h1.771a4.68,4.68,0,0,0-.4-1.118,3.258,3.258,0,0,0-.7-.919A3.194,3.194,0,0,0,77.881,9.9a4,4,0,0,0-1.428-.233,4.088,4.088,0,0,0-1.439.233,3.046,3.046,0,0,0-1.041.631,2.594,2.594,0,0,0-.631.919,2.9,2.9,0,0,0-.21,1.1,2.808,2.808,0,0,0,.709,1.971,5.061,5.061,0,0,0,2.214,1.262,9.333,9.333,0,0,1,1.2.476,2.8,2.8,0,0,1,.731.5,1.356,1.356,0,0,1,.354.554,2.1,2.1,0,0,1,.089.62,1.539,1.539,0,0,1-.443,1.118,1.778,1.778,0,0,1-1.329.454,2.03,2.03,0,0,1-1.495-.5,2.392,2.392,0,0,1-.653-1.207H72.732a5.059,5.059,0,0,0,.421,1.273,3.449,3.449,0,0,0,.753,1.019,3.312,3.312,0,0,0,1.129.675,4.5,4.5,0,0,0,1.55.244,3.765,3.765,0,0,0,2.613-.875,2.985,2.985,0,0,0,.974-2.336,3.339,3.339,0,0,0-.155-1.019,2.768,2.768,0,0,0-.509-.919,3.8,3.8,0,0,0-.941-.8,6.742,6.742,0,0,0-1.473-.653,6.478,6.478,0,0,1-1.163-.454,3.434,3.434,0,0,1-.675-.454,1.1,1.1,0,0,1-.321-.454,1.5,1.5,0,0,1-.078-.476,1.345,1.345,0,0,1,.432-1,1.721,1.721,0,0,1,1.251-.421,1.646,1.646,0,0,1,1.107.4A1.8,1.8,0,0,1,78.246,12.565Zm6.577,13.264,5.846-15.81H88.9L86.683,16.2q-.2.576-.376,1.118t-.354,1.118h-.044q-.044-.221-.133-.52t-.188-.62q-.1-.321-.21-.609T85.2,16.2l-2.237-6.178H81.169l3.9,10.607-1.926,5.2Zm7.462-7.152v1.949h1.949V18.677ZM94.234,5.524H92.285l.177,10.917h1.594Z",
    transform: "translate(5.725 9.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_822",
    "data-name": "Trazado 822",
    d: "M1270.945,1038.821a23.471,23.471,0,0,1-23.472,23.472h-74.2a23.359,23.359,0,0,1-10.434-2.437l-13.039,13.038v-34.072a23.472,23.472,0,0,1,23.472-23.471h74.2A23.472,23.472,0,0,1,1270.945,1038.821Z",
    transform: "translate(-1149.801 -1015.35)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1756",
    "data-name": "Grupo 1756",
    transform: "translate(-5240.811 2532.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1403",
    "data-name": "Trazado 1403",
    d: "M7.155,6.57V22.342H9.075V6.57Zm16.072,4.324a6.058,6.058,0,0,0-2.417.463,5.538,5.538,0,0,0-1.838,1.26A5.458,5.458,0,0,0,17.8,14.491a6.741,6.741,0,0,0,.035,4.694,5.454,5.454,0,0,0,1.237,1.885A5.721,5.721,0,0,0,20.949,22.3a6.21,6.21,0,0,0,2.37.439,5.693,5.693,0,0,0,1.977-.312,5.268,5.268,0,0,0,1.457-.8,4.717,4.717,0,0,0,1.018-1.1,5.277,5.277,0,0,0,.613-1.237H26.349a3.607,3.607,0,0,1-1.018,1.26,3.072,3.072,0,0,1-1.989.567,3.994,3.994,0,0,1-1.619-.324,3.871,3.871,0,0,1-1.283-.9,4.112,4.112,0,0,1-.844-1.364,4.82,4.82,0,0,1-.3-1.734,5.019,5.019,0,0,1,.324-1.873,4.063,4.063,0,0,1,.856-1.353,3.362,3.362,0,0,1,1.249-.809,4.287,4.287,0,0,1,1.5-.266,3.513,3.513,0,0,1,1.908.463,2.74,2.74,0,0,1,1.052,1.156h2.035a4.175,4.175,0,0,0-1.445-2.081,5.373,5.373,0,0,0-1.492-.809A5.947,5.947,0,0,0,23.227,10.895ZM41.566,22.342V11.265H39.739v1.6h-.023a6.66,6.66,0,0,0-.648-.694,4.529,4.529,0,0,0-.856-.624,5.362,5.362,0,0,0-1.087-.463,4.637,4.637,0,0,0-1.364-.185,5.912,5.912,0,0,0-2.3.439,5.651,5.651,0,0,0-1.838,1.226A5.564,5.564,0,0,0,30.4,14.433a6.64,6.64,0,0,0,.023,4.81,5.863,5.863,0,0,0,1.249,1.873,5.412,5.412,0,0,0,1.815,1.2,5.712,5.712,0,0,0,2.162.416,4.917,4.917,0,0,0,2.428-.567,5.494,5.494,0,0,0,1.619-1.307h.046v1.48Zm-9.713-5.55a4.976,4.976,0,0,1,.254-1.561,4.32,4.32,0,0,1,.752-1.388,3.614,3.614,0,0,1,1.272-.983,4.17,4.17,0,0,1,1.815-.37,3.779,3.779,0,0,1,2.787,1.2,4.239,4.239,0,0,1,.856,1.376,4.884,4.884,0,0,1,.312,1.792,4.293,4.293,0,0,1-.335,1.723,4.383,4.383,0,0,1-.89,1.341A4,4,0,0,1,37.4,20.8a3.725,3.725,0,0,1-1.5.312,3.871,3.871,0,0,1-3.8-2.74A5.266,5.266,0,0,1,31.853,16.792Zm12.9-5.527V22.342h1.827v-5.9a4.267,4.267,0,0,1,.879-2.925,3.034,3.034,0,0,1,2.382-.983,2.564,2.564,0,0,1,2.07.89,3.9,3.9,0,0,1,.752,2.578v6.336h1.827V15.89a6.024,6.024,0,0,0-.4-2.359,4.52,4.52,0,0,0-1.029-1.538,3.7,3.7,0,0,0-1.4-.844,4.907,4.907,0,0,0-1.538-.254,4.681,4.681,0,0,0-1.815.382,4.189,4.189,0,0,0-1.677,1.376h-.046V11.265ZM57.43,5.692V7.981h.833a9.213,9.213,0,0,1-.208,1.457,4.234,4.234,0,0,1-.578,1.364h1.156a7.848,7.848,0,0,0,.786-1.734,7.229,7.229,0,0,0,.324-2.243V5.692Zm4.209,5.573v1.526H63.1v5.781a9.217,9.217,0,0,0,.116,1.492,3.279,3.279,0,0,0,.463,1.249,2.39,2.39,0,0,0,.971.856,3.687,3.687,0,0,0,1.642.312A5.467,5.467,0,0,0,68,22.249v-1.5a5.024,5.024,0,0,1-1.341.185,2.5,2.5,0,0,1-.763-.1,1.182,1.182,0,0,1-.543-.358,1.622,1.622,0,0,1-.324-.705,5.091,5.091,0,0,1-.1-1.122V12.791h2.96V11.265h-2.96V7.727H63.1v3.538Zm13.436,0v1.526h1.6v9.551h1.85V12.791h2.544V11.265H78.52v-2.2a2.233,2.233,0,0,1,.428-1.422,1.588,1.588,0,0,1,1.33-.543,5.362,5.362,0,0,1,.636.035,2.834,2.834,0,0,1,.613.15V5.761a5.108,5.108,0,0,0-1.364-.185,3.368,3.368,0,0,0-2.613.96,3.916,3.916,0,0,0-.879,2.74v1.989Zm7.863,0V22.342h1.827V11.265Zm-.208-4.81V8.606h2.266V6.455Zm5.226,4.81V22.342h1.827v-5.9a4.267,4.267,0,0,1,.879-2.925,3.034,3.034,0,0,1,2.382-.983,2.564,2.564,0,0,1,2.07.89,3.9,3.9,0,0,1,.752,2.578v6.336h1.827V15.89a6.024,6.024,0,0,0-.4-2.359,4.52,4.52,0,0,0-1.029-1.538,3.7,3.7,0,0,0-1.4-.844,4.907,4.907,0,0,0-1.538-.254,4.681,4.681,0,0,0-1.815.382,4.189,4.189,0,0,0-1.677,1.376h-.046V11.265Zm23.634,11.077V5.692h-1.827v7.146h-.046a7.135,7.135,0,0,0-.752-.775,4.454,4.454,0,0,0-.89-.613,4.85,4.85,0,0,0-1.1-.4,5.9,5.9,0,0,0-1.4-.15,5.5,5.5,0,0,0-2.232.451,5.345,5.345,0,0,0-1.769,1.237,5.8,5.8,0,0,0-1.168,1.873,6.739,6.739,0,0,0,.023,4.787,5.906,5.906,0,0,0,1.214,1.873,5.2,5.2,0,0,0,1.781,1.2,5.625,5.625,0,0,0,2.151.416,5.137,5.137,0,0,0,2.509-.567,5.452,5.452,0,0,0,1.63-1.307h.046v1.48Zm-9.713-5.55a5.047,5.047,0,0,1,.254-1.584,4.076,4.076,0,0,1,.763-1.376,3.828,3.828,0,0,1,1.272-.971,4.037,4.037,0,0,1,1.781-.37,3.92,3.92,0,0,1,1.561.312,3.642,3.642,0,0,1,1.26.89,4.348,4.348,0,0,1,.844,1.376,4.884,4.884,0,0,1,.312,1.792A4.513,4.513,0,0,1,109.6,18.6a4,4,0,0,1-2.162,2.208,3.863,3.863,0,0,1-1.538.312,3.807,3.807,0,0,1-1.746-.382,4,4,0,0,1-1.26-.983,4.075,4.075,0,0,1-.763-1.376A5.046,5.046,0,0,1,101.876,16.792Zm18.685-5.527V22.342h1.827V11.265Zm-.208-4.81V8.606h2.266V6.455Zm4.024,4.81v1.526h1.457v5.781a9.217,9.217,0,0,0,.116,1.492,3.279,3.279,0,0,0,.463,1.249,2.39,2.39,0,0,0,.971.856,3.687,3.687,0,0,0,1.642.312,5.467,5.467,0,0,0,1.711-.231v-1.5a5.024,5.024,0,0,1-1.341.185,2.5,2.5,0,0,1-.763-.1,1.182,1.182,0,0,1-.543-.358,1.622,1.622,0,0,1-.324-.705,5.091,5.091,0,0,1-.1-1.122V12.791h2.96V11.265h-2.96V7.727h-1.827v3.538Zm8.649,9.042v2.035h2.035V20.307ZM135.061,6.57h-2.035l.185,11.4h1.665Z",
    transform: "translate(16.002 12.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_823",
    "data-name": "Trazado 823",
    d: "M381.5,1048.906a26.541,26.541,0,0,0,26.54,26.539H526.183a26.42,26.42,0,0,0,11.8-2.756l14.743,14.742v-38.524a26.542,26.542,0,0,0-26.54-26.54H408.04A26.541,26.541,0,0,0,381.5,1048.906Z",
    transform: "translate(-381.5 -1022.366)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1757",
    "data-name": "Grupo 1757",
    transform: "translate(-4823.607 2504.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_824",
    "data-name": "Trazado 824",
    d: "M1102.917,975.739a28.74,28.74,0,0,1-28.738,28.739h-35.228a28.6,28.6,0,0,1-12.776-2.985l-15.964,15.964V975.739A28.74,28.74,0,0,1,1038.951,947h35.228A28.74,28.74,0,0,1,1102.917,975.739Z",
    transform: "translate(-1010.212 -947)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1404",
    "data-name": "Trazado 1404",
    d: "M22.157,18.362q.52-.52,1.086-1.132A10.259,10.259,0,0,0,24.3,15.869a7.194,7.194,0,0,0,.8-1.667,6.352,6.352,0,0,0,.306-2.019,5.7,5.7,0,0,0-.382-2.064,5.106,5.106,0,0,0-1.132-1.759,5.44,5.44,0,0,0-1.9-1.223,7.176,7.176,0,0,0-2.676-.459,6.77,6.77,0,0,0-2.416.428,5.979,5.979,0,0,0-1.973,1.208,5.674,5.674,0,0,0-1.33,1.881,6.247,6.247,0,0,0-.52,2.416h2.661a4.127,4.127,0,0,1,.275-1.545,3.41,3.41,0,0,1,.749-1.162,3.144,3.144,0,0,1,1.116-.719,3.748,3.748,0,0,1,1.346-.245,3.894,3.894,0,0,1,1.514.275,3.31,3.31,0,0,1,1.116.749,3.093,3.093,0,0,1,.688,1.1,3.932,3.932,0,0,1,.229,1.361,3.658,3.658,0,0,1-.214,1.3,5.164,5.164,0,0,1-.6,1.116,9.629,9.629,0,0,1-.918,1.116q-.535.566-1.177,1.3a7.2,7.2,0,0,0-.887,1.193,5.688,5.688,0,0,0-.52,1.177,6.238,6.238,0,0,0-.245,1.285q-.061.688-.061,1.514h2.233a6.989,6.989,0,0,1,.092-1.177,4.4,4.4,0,0,1,.306-1.025,4.576,4.576,0,0,1,.551-.933A9.219,9.219,0,0,1,22.157,18.362Zm-4.251,7.157V28.21H20.6V25.519Zm20.889-7.157q.52-.52,1.086-1.132a10.259,10.259,0,0,0,1.055-1.361,7.2,7.2,0,0,0,.8-1.667,6.352,6.352,0,0,0,.306-2.019,5.7,5.7,0,0,0-.382-2.064,5.106,5.106,0,0,0-1.132-1.759,5.44,5.44,0,0,0-1.9-1.223,7.176,7.176,0,0,0-2.676-.459,6.77,6.77,0,0,0-2.416.428,5.979,5.979,0,0,0-1.973,1.208,5.674,5.674,0,0,0-1.33,1.881,6.247,6.247,0,0,0-.52,2.416h2.661a4.127,4.127,0,0,1,.275-1.545A3.41,3.41,0,0,1,33.4,9.905a3.143,3.143,0,0,1,1.116-.719,3.748,3.748,0,0,1,1.346-.245,3.894,3.894,0,0,1,1.514.275,3.31,3.31,0,0,1,1.116.749,3.093,3.093,0,0,1,.688,1.1,3.932,3.932,0,0,1,.229,1.361,3.658,3.658,0,0,1-.214,1.3,5.164,5.164,0,0,1-.6,1.116,9.629,9.629,0,0,1-.918,1.116q-.535.566-1.177,1.3a7.2,7.2,0,0,0-.887,1.193,5.688,5.688,0,0,0-.52,1.177,6.238,6.238,0,0,0-.245,1.285q-.061.688-.061,1.514h2.233a6.99,6.99,0,0,1,.092-1.177,4.4,4.4,0,0,1,.306-1.025,4.576,4.576,0,0,1,.551-.933A9.22,9.22,0,0,1,38.795,18.362Zm-4.251,7.157V28.21h2.691V25.519Z",
    transform: "translate(19.545 12.892)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1758",
    "data-name": "Grupo 1758",
    transform: "translate(-4682.349 2472.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_825",
    "data-name": "Trazado 825",
    d: "M910.077,902.964a30.005,30.005,0,0,1-30,30H843.293a29.861,29.861,0,0,1-13.338-3.116l-16.667,16.667V902.964a30.007,30.007,0,0,1,30-30h36.779A30.006,30.006,0,0,1,910.077,902.964Z",
    transform: "translate(-813.288 -872.959)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_876",
    "data-name": "Grupo 876",
    transform: "translate(33.494 13.617)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_137",
    "data-name": "Elipse 137",
    cx: 16.645,
    cy: 16.645,
    r: 16.645,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_826",
    "data-name": "Trazado 826",
    d: "M860.375,905.648l7.282,8.323L879.1,900.446",
    transform: "translate(-853.613 -890.563)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_309",
    "data-name": "L\\xEDnea 309",
    y2: 188.085,
    transform: "translate(-5153.253 2323.989)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: "5 10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1409",
    "data-name": "Trazado 1409",
    d: "M0-44.056V149.273",
    transform: "translate(-4477.509 2365.423)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "5 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_310",
    "data-name": "L\\xEDnea 310",
    y2: 153.647,
    transform: "translate(-4984.023 2285.768)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: "5 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_311",
    "data-name": "L\\xEDnea 311",
    y2: 165.045,
    transform: "translate(-4815.969 2323.989)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: "5 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_312",
    "data-name": "L\\xEDnea 312",
    y2: 92.128,
    transform: "translate(-4646.739 2347.287)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: "5 10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1759",
    "data-name": "Grupo 1759",
    transform: "translate(-4241.514 1862.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_762",
    "data-name": "Trazado 762",
    d: "M1548.409,404.869c25.372-112.253-30.154-113.184-23.561-201.153",
    transform: "translate(-1347.498 -180.875)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_763",
    "data-name": "Trazado 763",
    d: "M1366.983,404.869c-25.372-112.253,30.154-113.184,23.561-201.153",
    transform: "translate(-1323.709 -180.875)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 45
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_97",
    "data-name": "Elipse 97",
    cx: 113.707,
    cy: 18.809,
    rx: 113.707,
    ry: 18.809
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1760",
    "data-name": "Grupo 1760",
    transform: "translate(-4215.996 2054.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_902",
    "data-name": "Grupo 902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_880",
    "data-name": "Grupo 880",
    transform: "translate(0 37.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_878",
    "data-name": "Grupo 878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_827",
    "data-name": "Trazado 827",
    d: "M1369.659,548.38a9.341,9.341,0,0,0,5.606-11.961c-3.006-8.3-4.983-19.679-6.239-30.495a9.34,9.34,0,0,0,15.847-9.785c-4.96-9.61.044-31.923.044-31.923a15.863,15.863,0,0,0-30.321-8.749l-.057.006c-5.606,9.838-6.511,12.865-6.878,14.9-.843,4.675.16,18.986,1.451,30.306,1.395,12.23,4.015,29.464,8.587,42.1A9.339,9.339,0,0,0,1369.659,548.38Z",
    transform: "translate(-1347.349 -445.54)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_879",
    "data-name": "Grupo 879",
    transform: "translate(15.64 36.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_828",
    "data-name": "Trazado 828",
    d: "M1365.646,487.9a48.21,48.21,0,0,0,5.279,22.95,9.34,9.34,0,0,0,12.584,4.016",
    transform: "translate(-1365.643 -487.901)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_901",
    "data-name": "Grupo 901",
    transform: "translate(4.461)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_138",
    "data-name": "Elipse 138",
    cx: 16.831,
    cy: 16.831,
    r: 16.831,
    transform: "translate(94.036 6.91)",
    fill: "#ffc0d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_881",
    "data-name": "Grupo 881",
    transform: "translate(10.245 64.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_829",
    "data-name": "Trazado 829",
    d: "M1364.551,528.058l39.687-51.226v66.878l-39.642,39.642Z",
    transform: "translate(-1364.551 -476.833)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_754",
    "data-name": "Rect\\xE1ngulo 754",
    width: 117.283,
    height: 110.501,
    transform: "translate(39.687)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_755",
    "data-name": "Rect\\xE1ngulo 755",
    width: 117.283,
    height: 110.501,
    transform: "translate(0 51.226)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_190",
    "data-name": "L\\xEDnea 190",
    y1: 51.226,
    x2: 39.687,
    transform: "translate(117.283 110.501)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_900",
    "data-name": "Grupo 900",
    transform: "translate(3.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_899",
    "data-name": "Grupo 899",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_889",
    "data-name": "Grupo 889",
    transform: "translate(32.408 24.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_888",
    "data-name": "Grupo 888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_884",
    "data-name": "Grupo 884",
    transform: "translate(69.354 1.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_882",
    "data-name": "Grupo 882"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_191",
    "data-name": "L\\xEDnea 191",
    y2: 57.659,
    transform: "translate(30.004)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_192",
    "data-name": "L\\xEDnea 192",
    x2: 60.007,
    transform: "translate(0 28.829)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_883",
    "data-name": "Grupo 883",
    transform: "translate(8.788 7.614)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_193",
    "data-name": "L\\xEDnea 193",
    x1: 40.771,
    y2: 40.771,
    transform: "translate(0.83 0.83)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_194",
    "data-name": "L\\xEDnea 194",
    x2: 42.431,
    y2: 42.431,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_885",
    "data-name": "Grupo 885",
    transform: "translate(0 14.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_830",
    "data-name": "Trazado 830",
    d: "M1461.892,547.924c-24.265,6.61-50.781-5.663-62.016-30.021s-3.358-52.495,17.422-66.661",
    transform: "translate(-1394.753 -447.549)",
    fill: "#0067ec",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_139",
    "data-name": "Elipse 139",
    cx: 8.444,
    cy: 53.42,
    rx: 8.444,
    ry: 53.42,
    transform: "matrix(0.908, -0.419, 0.419, 0.908, 14.774, 7.073)",
    fill: "#0067ec",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_140",
    "data-name": "Elipse 140",
    cx: 7.044,
    cy: 7.044,
    r: 7.044,
    transform: "translate(65.105 75.369)",
    fill: "#fffaf0",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_887",
    "data-name": "Grupo 887",
    transform: "translate(21.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_886",
    "data-name": "Grupo 886",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_831",
    "data-name": "Trazado 831",
    d: "M1435.355,446.131a26.078,26.078,0,1,1-30.795,42.045",
    transform: "translate(-1417.334 -432.496)",
    fill: "none",
    stroke: "#ff3900",
    strokeMiterlimit: 10,
    strokeWidth: 23
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_898",
    "data-name": "Grupo 898",
    transform: "translate(51.355 50.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_756",
    "data-name": "Rect\\xE1ngulo 756",
    width: 79.007,
    height: 101.925,
    transform: "translate(31.57 0) rotate(18.044)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_896",
    "data-name": "Grupo 896",
    transform: "translate(23.645 11.341)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_141",
    "data-name": "Elipse 141",
    cx: 9.398,
    cy: 9.398,
    r: 9.398,
    transform: "translate(28.815 41.327)",
    fill: "#0067ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_757",
    "data-name": "Rect\\xE1ngulo 757",
    width: 32.843,
    height: 40.574,
    transform: "translate(48.751 19.351) rotate(108.044)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_890",
    "data-name": "Grupo 890",
    transform: "translate(9.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_833",
    "data-name": "Trazado 833",
    d: "M1455.86,481.306a15.115,15.115,0,0,1,6.01-7.9l4.056,6.133a7.629,7.629,0,0,0-3.074,4.043,7.716,7.716,0,0,0,12.086,8.471l4.518,5.8a15.07,15.07,0,0,1-23.6-16.55Z",
    transform: "translate(-1455.118 -473.407)",
    fill: "#ffc0d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_892",
    "data-name": "Grupo 892",
    transform: "translate(28.815 41.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_891",
    "data-name": "Grupo 891",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_758",
    "data-name": "Rect\\xE1ngulo 758",
    width: 32.843,
    height: 40.574,
    transform: "translate(19.936 -21.976) rotate(108.044)",
    fill: "#fffaf0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_895",
    "data-name": "Grupo 895",
    transform: "translate(0 6.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_894",
    "data-name": "Grupo 894",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_893",
    "data-name": "Grupo 893",
    transform: "translate(9.015 -6.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_834",
    "data-name": "Trazado 834",
    d: "M1455.86,481.306a15.115,15.115,0,0,1,6.01-7.9l4.056,6.133a7.629,7.629,0,0,0-3.074,4.043,7.716,7.716,0,0,0,12.086,8.471l4.518,5.8a15.07,15.07,0,0,1-23.6-16.55Z",
    transform: "translate(-1455.118 -473.407)",
    fill: "#ff3900"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_897",
    "data-name": "Grupo 897",
    transform: "translate(13.394 67.493)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_195",
    "data-name": "L\\xEDnea 195",
    x2: 50.861,
    y2: 16.569,
    transform: "translate(4.312)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_196",
    "data-name": "L\\xEDnea 196",
    x2: 50.861,
    y2: 16.569,
    transform: "translate(2.156 6.619)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_197",
    "data-name": "L\\xEDnea 197",
    x2: 28.71,
    y2: 9.353,
    transform: "translate(0 13.237)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_836",
    "data-name": "Trazado 836",
    d: "M1362.812,536.75l-10.245,34.76h122.375l5.154-34.76Z",
    transform: "translate(-1352.567 -421.168)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_837",
    "data-name": "Trazado 837",
    d: "M1501.733,528.058l39.687-51.226,31.6,17.115-35.646,53.036Z",
    transform: "translate(-1369.743 -412.477)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_905",
    "data-name": "Grupo 905",
    transform: "translate(152.922 43.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_903",
    "data-name": "Grupo 903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_838",
    "data-name": "Trazado 838",
    d: "M1533.853,553.578a9.342,9.342,0,0,1-3.394-12.767c4.432-7.639,8.395-18.482,11.55-28.9a9.339,9.339,0,0,1-13.86-12.44c6.585-8.578,5.621-31.424,5.621-31.424a15.862,15.862,0,0,1,31.391-3.232l.055.016c3.772,10.676,4.126,13.816,4.126,15.883,0,4.749-3.526,18.656-6.8,29.567-3.542,11.789-9.178,28.284-15.919,39.906A9.34,9.34,0,0,1,1533.853,553.578Z",
    transform: "translate(-1526.217 -452.184)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_904",
    "data-name": "Grupo 904",
    transform: "translate(3.652 37.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_839",
    "data-name": "Trazado 839",
    d: "M1552.852,495.474a48.207,48.207,0,0,1-9.267,21.649,9.34,9.34,0,0,1-13.1,1.72",
    transform: "translate(-1530.489 -495.474)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1761",
    "data-name": "Grupo 1761",
    transform: "matrix(0.921, 0.391, -0.391, 0.921, -4332.669, 2236.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_870",
    "data-name": "Trazado 870",
    d: "M0,20.616C117.25,109.205,154.867,0,154.867,0",
    transform: "translate(0 1.582)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_978",
    "data-name": "Grupo 978",
    transform: "translate(145.179 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_871",
    "data-name": "Trazado 871",
    d: "M11.359,8.2,10.693.53c-.03-.356-.427-.69-.778-.446A48.992,48.992,0,0,1,.344,5.27c-.609.247-.342,1.247.275,1A50.185,50.185,0,0,0,10.437.976L9.66.53,10.326,8.2c.056.658,1.092.664,1.033,0Z",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Great_Solution",
    "data-name": "Great Solution",
    transform: "translate(-4190.8 2225.718) rotate(-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1621",
    "data-name": "Grupo 1621",
    transform: "translate(9.866 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1338",
    "data-name": "Trazado 1338",
    d: "M13.386,12.36c.082-2.321-.181-2.576-2.288-2.226a6.156,6.156,0,0,1-1.627-.079c-.777-.07-.925.121-.713.839a3.676,3.676,0,0,1-1.437,4.27c-.447.341-.826.811-1.48.751a4.928,4.928,0,0,1-3.027-1.17A10.4,10.4,0,0,1,.75,11.879,5.589,5.589,0,0,1,0,9.075a13.482,13.482,0,0,1,1.1-4.827A11.808,11.808,0,0,1,3.254.93,1.416,1.416,0,0,1,4.462.377c.344.038.768-.1.938.38a1.089,1.089,0,0,1-.2,1.158,10.288,10.288,0,0,0-2.37,4.5,6.169,6.169,0,0,0,.73,5.383,6.7,6.7,0,0,0,1.391,1.312c.528.43,1.309-.115,1.443-.938a1.677,1.677,0,0,0-.946-2c-.584-.332-.763-1.023-1.325-1.358-.034-.021-.014-.17.011-.249.258-.789.9-1.611,2.018-1.236A5.581,5.581,0,0,0,8.6,7.5a11.69,11.69,0,0,1,3.82.242.812.812,0,0,0,.976-.663,10.361,10.361,0,0,1,1.343-4.343c.348-.513.118-1.121.066-1.679-.054-.583.115-.927.724-1.019.851-.129,1.456.095,1.553.7.072.449.233.515.63.444a2.743,2.743,0,0,1,3.087,2.877c-.024.644.135,1.3.112,1.968a8.2,8.2,0,0,1-1.326,4.261c-.476.736-.427,1.05.268,1.954.265.345.576.655.826,1.009.191.27.413.161.611.1a5.138,5.138,0,0,0,2.42-3.381.887.887,0,0,0-.081-.463c-.538-.818.345-.94,1.053-1.261a.819.819,0,0,0,.46-.87,6.633,6.633,0,0,1,.141-2.377,1.661,1.661,0,0,0-.224-1.231c-.483-.918-.316-1.265.652-1.591a14.661,14.661,0,0,1,6.519-.721.776.776,0,0,1,.614.417c.221.465-.2.8-.6,1.1A13.888,13.888,0,0,1,28.4,4.6a.688.688,0,0,0-.51.566,8.049,8.049,0,0,0,.06,3c.148.738.917.471,1.444.532.2.023.406-.071.609-.069.3,0,.638.024.72.386.077.337.275.695-.089,1.023-.439.4-.726.956-1.3,1.208-.353.155-.305.463-.2.7a8.682,8.682,0,0,0,1.8,2.389c.237.26.656.146.988.223.614.144.812.432.536.98-.791,1.572-1.656,1.807-2.923.8a8.909,8.909,0,0,1-2.973-4.161.779.779,0,0,0-.458-.56c-.275-.082-.358.21-.5.379a20.781,20.781,0,0,1-2.55,3.051,11.718,11.718,0,0,1-1.338.835,1.191,1.191,0,0,1-1.176.009,4.07,4.07,0,0,1-2.21-2.194,4.645,4.645,0,0,0-1.075-1.32c-.276-.3-.654-.094-.807.282a11.872,11.872,0,0,0-.46,1.368,1.9,1.9,0,0,1-.474.824c-.459.488-.612.427-1.1-.052A2.63,2.63,0,0,1,13.386,12.36Zm5.453-7.342a.794.794,0,0,0,.012-.183c-.012-.227-.019-.349-.023-.47-.019-.516-.124-.986-.76-1.019-.535-.028-.919.422-1.027,1.065-.073.431.173.845,0,1.284a7.728,7.728,0,0,0-.221,2.036,1.049,1.049,0,0,0,.735,1.052c.38.126.438-.365.593-.626A8.479,8.479,0,0,0,18.838,5.018Z",
    transform: "translate(0 0.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1339",
    "data-name": "Trazado 1339",
    d: "M7.643,10.156a6.891,6.891,0,0,1-2.9-.137.663.663,0,0,0-.868.453,6.945,6.945,0,0,0-.541,2.663A2.432,2.432,0,0,1,2.073,15.4.8.8,0,0,1,.9,15.095a9.037,9.037,0,0,0-.732-1.27A1.3,1.3,0,0,1,.212,12.5,16.085,16.085,0,0,0,.883,9.528a21,21,0,0,1,.541-2.717,36.33,36.33,0,0,0,1.11-4.023A18.586,18.586,0,0,1,3.654.306C3.841-.162,4.448,0,4.833.181a2.051,2.051,0,0,0,1.59.141.668.668,0,0,1,.639.146A4.287,4.287,0,0,1,8.8,2.835c.215.947.728,1.825.962,2.769a24.114,24.114,0,0,1,.9,3.358,20.889,20.889,0,0,1,.036,4.484,1.845,1.845,0,0,1-1.146,1.426c-.353.2-.668-.088-.921-.306A1.091,1.091,0,0,1,8.2,13.344a8.988,8.988,0,0,0,.31-2.311C8.57,10.318,8.367,10.122,7.643,10.156ZM6.9,7.943c1.422.031,1.261-.249.6-1.59a.877.877,0,0,1-.083-.4,5.082,5.082,0,0,0-.634-2.262c-.19-.383-.4-.436-.673,0-.493.8-.668,1.729-1.1,2.558-.341.657,0,1.226.8,1.5C6.162,7.876,6.524,8.094,6.9,7.943Z",
    transform: "translate(33.248 1.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1340",
    "data-name": "Trazado 1340",
    d: "M1.974,3.142c-.236-.032-.785.219-1-.194C.652,2.31.054,1.8,0,1.033A.645.645,0,0,1,.624.275,5.945,5.945,0,0,1,1.24.214,5.968,5.968,0,0,0,3.531.032a.88.88,0,0,1,.54.027,62.5,62.5,0,0,1,6.178,1.726,6.812,6.812,0,0,1,.663.342.749.749,0,0,1,.412.863.8.8,0,0,1-.665.61,5.38,5.38,0,0,1-2.311.07c-.677-.1-1.36-.169-2.04-.249-.308-.037-.36.077-.344.4.066,1.3.5,2.547.465,3.871a35.842,35.842,0,0,0,.225,4.37c.066.69.031,1.393.149,2.093a1.925,1.925,0,0,1-1.091,1.628c-.166.057-.347.077-.447-.058-.5-.666-1.162-1.217-1.18-2.175-.039-2.17-.1-4.342-.227-6.509-.065-1.114-.386-2.2-.405-3.332a.532.532,0,0,0-.629-.566C2.6,3.157,2.365,3.142,1.974,3.142Z",
    transform: "translate(45.768 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1622",
    "data-name": "Grupo 1622",
    transform: "translate(0 27.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1341",
    "data-name": "Trazado 1341",
    d: "M11.192,3.75c.058-.686-.027-1.371.064-2.061.13-.977.3-1.155,1.3-1.12,1.028.036,1.371.428,1.435,1.4.073,1.128-.172,2.231-.15,3.359a9.738,9.738,0,0,0,.8,3.755c.3.689.758.705,1.391.3a4.168,4.168,0,0,0,1.595-2.322,7.377,7.377,0,0,1,.632-1.441A6.991,6.991,0,0,0,19,2.654c.178-1.3.316-1.5,1.559-1.278.575.1.776-.01.877-.577.108-.607.632-.736,1.168-.746C23.57.036,24.5.387,25.467.346c.158-.007.374.09.465.016,1-.805,1.859-.055,2.762.21a.321.321,0,0,1,.121.065c.337.3.971.213,1.122.7s-.416.7-.6,1.08a4.253,4.253,0,0,0-.16,2.5,46.132,46.132,0,0,1,.286,5.274,8.391,8.391,0,0,1-.061,1.778,1.173,1.173,0,0,1-.926.985c-.506.14-.788-.152-1.028-.5a3.559,3.559,0,0,1-.606-2.32c.073-1.363-.021-2.737-.081-4.1-.036-.819-.169-1.634-.212-2.453-.024-.455-.2-.583-.638-.543a15.839,15.839,0,0,1-2.746-.077,1.692,1.692,0,0,1-.832-.3c-.143-.1-.255-.325-.463-.2s-.164.355-.183.562a16.284,16.284,0,0,0-.014,3.084c.16,1.594.044,3.2.219,4.787a1.778,1.778,0,0,0,.6,1.252c.595.513.542.833-.124,1.288-.477.326-.925.673-1.569.379a1.114,1.114,0,0,1-.463-.369,6.439,6.439,0,0,1-1.055-3.464c-.015-.176.08-.417-.129-.5-.24-.09-.361.143-.469.31a7.528,7.528,0,0,1-2.4,2.5,1.727,1.727,0,0,1-1.927-.021A4.171,4.171,0,0,1,12.8,10.735c-.293-.485-.551-.474-.829.044-.41.765-.867,1.5-1.3,2.258-.529.923-1.031,1.058-2.055.8a7.143,7.143,0,0,0-3.3-.287c-1.919.376-3.255-.232-4.105-2.365A.54.54,0,0,0,1.11,11c-.774-.8-.517-1.829-.665-2.777C.107,6.051.362,3.844.038,1.67-.146.438.349.028,1.378.273a.567.567,0,0,0,.205,0c1-.147,1.667.272,1.428,1.652a10.375,10.375,0,0,0,.012,2.053,45.762,45.762,0,0,0,.33,5.336,1.769,1.769,0,0,0,1.635,1.274,12.909,12.909,0,0,1,3.807-.074.47.47,0,0,0,.551-.188c.45-.856,1.249-1.556,1.187-2.645a.8.8,0,0,1,.068-.471C11.36,6.145,11.147,4.926,11.192,3.75Z",
    transform: "translate(16.91 2.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1342",
    "data-name": "Trazado 1342",
    d: "M13.555,2.635c-.394.965.2,1.144.915,1.525A3.521,3.521,0,0,1,16.317,6.23a11.393,11.393,0,0,1,.663,2.623,7.68,7.68,0,0,1-.548,3.238,7.859,7.859,0,0,1-1.769,2.8,2.989,2.989,0,0,1-4.524-.013,4.989,4.989,0,0,1-1.457-2.558c-.023-.266-.2-.676-.63-.212a5.866,5.866,0,0,1-4.4,1.75c-.558.012-1.088.151-1.634.188-.65.044-1.233-.066-1.494-.784a.954.954,0,0,0-.184-.285c-.614-.7-.387-1.383.535-1.568a10.177,10.177,0,0,1,3.046-.288,2.622,2.622,0,0,0,1.843-.8.6.6,0,0,0,.01-.964,13.228,13.228,0,0,0-2.127-1.8C3.16,7.288,2.874,6.715,2.4,6.5,1.342,6,1.35,5.033,1.229,4.153a3.207,3.207,0,0,1,1.85-2.658,1.96,1.96,0,0,0,.58-.356A4.765,4.765,0,0,1,7.693.054,1.135,1.135,0,0,1,8.8,1.238,1.459,1.459,0,0,1,7.713,2.706a.679.679,0,0,1-.333-.013A3.351,3.351,0,0,0,3.985,3.881a.56.56,0,0,0,.122.795A15.71,15.71,0,0,0,6.319,6.391a5.286,5.286,0,0,1,1,1.027c.208.224.429.458.762.368s.359-.427.37-.68c.1-2.254,1.317-3.946,2.736-5.545.512-.577,1.083-.216,1.592-.066S13.769,1.953,13.555,2.635ZM10.914,8.986a8.266,8.266,0,0,0,.318,2.783c.112.551.386,1.169,1,1.284.59.111,1.033-.391,1.314-.835a5.769,5.769,0,0,0,.686-4.772A1.2,1.2,0,0,0,12.758,6.4c-.241.037-.361-.164-.522-.282-.647-.478-.886-.406-1.056.375A8.677,8.677,0,0,0,10.914,8.986Z",
    transform: "translate(0 1.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1343",
    "data-name": "Trazado 1343",
    d: "M3.818,4.792c.337-.544.761-.778.973-1.239a1.544,1.544,0,0,1,1.83-.691A3.248,3.248,0,0,1,9.061,5.011,19.727,19.727,0,0,1,10.082,8.1a15,15,0,0,0,.906,2.57c.056.165.065.407.29.419s.271-.211.333-.383a28.161,28.161,0,0,0,1.733-7.172,1.485,1.485,0,0,1,.6-1.244c.43-.248.829.073,1.263.236.934.351.773,1,.628,1.665-.372,1.7-.87,3.368-1.239,5.057-.3,1.395-.889,2.688-1.169,4.083a3.374,3.374,0,0,1-1.253,1.842c-.5.416-1.744-.144-1.941-.853A21.411,21.411,0,0,0,8.979,11.39c-.341-.767-.536-1.6-.819-2.393-.382-1.07-.8-2.128-1.173-3.2-.164-.472-.422-.352-.667-.139A4.336,4.336,0,0,0,5.259,7.318c-.542,1.3-.955,2.645-1.519,3.929a9.067,9.067,0,0,0-.721,2.5,1.577,1.577,0,0,1-.774,1.291c-.888.515-1.114.451-1.536-.489a1.252,1.252,0,0,0-.3-.447,1.187,1.187,0,0,1-.362-1.255c.463-2.151.529-4.349.82-6.52.1-.749.207-1.5.328-2.243A14.431,14.431,0,0,0,1.356.93C1.312.15,1.92-.217,2.626.133c1.006.5,1.282,1.085,1.2,2.365C3.781,3.2,3.818,3.907,3.818,4.792Z",
    transform: "translate(65.44 2.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1344",
    "data-name": "Trazado 1344",
    d: "M4.937,2.777a4.764,4.764,0,0,1,2.58,1.146,2.169,2.169,0,0,1,.605,1.406c.061.889.1,1.784.075,2.675-.018.786-.5,1.473-.586,2.251a7.7,7.7,0,0,1-.967,2.322,3.072,3.072,0,0,1-4.017,1.57,1.174,1.174,0,0,1-.481-.368A7.54,7.54,0,0,1,.182,6.961C.538,5.381.694,3.683,1.9,2.324c.428-.484.577-1.3,1.271-1.565C3.932.467,4.584-.308,5.561.133c.342.154.9.122.869.607-.038.59-.115,1.26-.817,1.539C5.363,2.378,5.088,2.433,4.937,2.777Zm.846,4.061A2.4,2.4,0,0,0,4.863,4.3c-.206-.168-.2-.4-.261-.612-.05-.163.037-.424-.2-.46s-.308.21-.417.384A9.476,9.476,0,0,0,2.756,10a2.494,2.494,0,0,0,.39,1.007c.248.384.537.551.987.114A5.652,5.652,0,0,0,5.784,6.838Z",
    transform: "translate(56.504 2.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1345",
    "data-name": "Trazado 1345",
    d: "M2,0c.867-.006,1.243.445,1.106,1.273a4.125,4.125,0,0,1-.394,1.459c-.2.359.008,1.011.025,1.533a50.509,50.509,0,0,1-.006,6.483A29.842,29.842,0,0,0,2.771,14.1,2.862,2.862,0,0,1,2,15.815a.553.553,0,0,1-.941.007A3.8,3.8,0,0,1,.008,12.968c.17-2.687.217-5.382.271-8.074a5.969,5.969,0,0,1-.03-1.632C.275,3.174.245,3.039.3,3c.609-.49.351-1.127.353-1.744C.654.335,1.058.007,2,0Z",
    transform: "translate(51.406 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3168",
    "data-name": "Grupo 3168",
    transform: "translate(0 102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1405",
    "data-name": "Trazado 1405",
    d: "M-11801-4871.586h1153.465",
    transform: "translate(6167.087 6538.555)",
    fill: "none",
    stroke: "#256ae4",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("text", {
    id: "Understand",
    transform: "translate(-5570.5 1634)",
    fill: "#0067ec",
    fontSize: 22,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -64.482,
    y: 0
  }, "Understand")), /*#__PURE__*/React.createElement("text", {
    id: "Create",
    transform: "translate(-4461.25 1634)",
    fill: "#ff3900",
    fontSize: 22,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -37.675,
    y: 0
  }, "Create")), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1410",
    "data-name": "Trazado 1410",
    d: "M-11295.662-4871.586H-11801",
    transform: "translate(7301.162 6538.555)",
    fill: "none",
    stroke: "#ec4b27",
    strokeWidth: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproach);
export default __webpack_public_path__ + "static/media/approach.da69be5263621d72c46eedf25738bcef.svg";
export { ForwardRef as ReactComponent };